export interface LookupEntry {
  language: string;
  location: string | null;
  id: number;
  tag: string;
  version?: string;
}

const lookup: Record<string, LookupEntry> = {
  aa: {
    language: "Afar",
    location: null,
    id: 4096,
    tag: "aa",
  },
  "aa-dj": {
    language: "Afar",
    location: "Djibouti",
    id: 4096,
    tag: "aa-DJ",
  },
  "aa-er": {
    language: "Afar",
    location: "Eritrea",
    id: 4096,
    tag: "aa-ER",
  },
  "aa-et": {
    language: "Afar",
    location: "Ethiopia",
    id: 4096,
    tag: "aa-ET",
  },
  af: {
    language: "Afrikaans",
    location: null,
    id: 54,
    tag: "af",
  },
  "af-na": {
    language: "Afrikaans",
    location: "Namibia",
    id: 4096,
    tag: "af-NA",
  },
  "af-za": {
    language: "Afrikaans",
    location: "South Africa",
    id: 1078,
    tag: "af-ZA",
  },
  agq: {
    language: "Aghem",
    location: null,
    id: 4096,
    tag: "agq",
  },
  "agq-cm": {
    language: "Aghem",
    location: "Cameroon",
    id: 4096,
    tag: "agq-CM",
  },
  ak: {
    language: "Akan",
    location: null,
    id: 4096,
    tag: "ak",
  },
  "ak-gh": {
    language: "Akan",
    location: "Ghana",
    id: 4096,
    tag: "ak-GH",
  },
  sq: {
    language: "Albanian",
    location: null,
    id: 28,
    tag: "sq",
  },
  "sq-al": {
    language: "Albanian",
    location: "Albania",
    id: 1052,
    tag: "sq-AL",
  },
  "sq-mk": {
    language: "Albanian",
    location: "North Macedonia",
    id: 4096,
    tag: "sq-MK",
  },
  gsw: {
    language: "Alsatian",
    location: null,
    id: 132,
    tag: "gsw",
  },
  "gsw-fr": {
    language: "Alsatian",
    location: "France",
    id: 1156,
    tag: "gsw-FR",
  },
  "gsw-li": {
    language: "Alsatian",
    location: "Liechtenstein",
    id: 4096,
    tag: "gsw-LI",
  },
  "gsw-ch": {
    language: "Alsatian",
    location: "Switzerland",
    id: 4096,
    tag: "gsw-CH",
  },
  am: {
    language: "Amharic",
    location: null,
    id: 94,
    tag: "am",
  },
  "am-et": {
    language: "Amharic",
    location: "Ethiopia",
    id: 1118,
    tag: "am-ET",
  },
  ar: {
    language: "Arabic",
    location: null,
    id: 1,
    tag: "ar",
  },
  "ar-dz": {
    language: "Arabic",
    location: "Algeria",
    id: 5121,
    tag: "ar-DZ",
  },
  "ar-bh": {
    language: "Arabic",
    location: "Bahrain",
    id: 15361,
    tag: "ar-BH",
  },
  "ar-td": {
    language: "Arabic",
    location: "Chad",
    id: 4096,
    tag: "ar-TD",
  },
  "ar-km": {
    language: "Arabic",
    location: "Comoros",
    id: 4096,
    tag: "ar-KM",
  },
  "ar-dj": {
    language: "Arabic",
    location: "Djibouti",
    id: 4096,
    tag: "ar-DJ",
  },
  "ar-eg": {
    language: "Arabic",
    location: "Egypt",
    id: 3073,
    tag: "ar-EG",
  },
  "ar-er": {
    language: "Arabic",
    location: "Eritrea",
    id: 4096,
    tag: "ar-ER",
  },
  "ar-iq": {
    language: "Arabic",
    location: "Iraq",
    id: 2049,
    tag: "ar-IQ",
  },
  "ar-il": {
    language: "Arabic",
    location: "Israel",
    id: 4096,
    tag: "ar-IL",
  },
  "ar-jo": {
    language: "Arabic",
    location: "Jordan",
    id: 11265,
    tag: "ar-JO",
  },
  "ar-kw": {
    language: "Arabic",
    location: "Kuwait",
    id: 13313,
    tag: "ar-KW",
  },
  "ar-lb": {
    language: "Arabic",
    location: "Lebanon",
    id: 12289,
    tag: "ar-LB",
  },
  "ar-ly": {
    language: "Arabic",
    location: "Libya",
    id: 4097,
    tag: "ar-LY",
  },
  "ar-mr": {
    language: "Arabic",
    location: "Mauritania",
    id: 4096,
    tag: "ar-MR",
  },
  "ar-ma": {
    language: "Arabic",
    location: "Morocco",
    id: 6145,
    tag: "ar-MA",
  },
  "ar-om": {
    language: "Arabic",
    location: "Oman",
    id: 8193,
    tag: "ar-OM",
  },
  "ar-ps": {
    language: "Arabic",
    location: "Palestinian Authority",
    id: 4096,
    tag: "ar-PS",
  },
  "ar-qa": {
    language: "Arabic",
    location: "Qatar",
    id: 16385,
    tag: "ar-QA",
  },
  "ar-sa": {
    language: "Arabic",
    location: "Saudi Arabia",
    id: 1025,
    tag: "ar-SA",
  },
  "ar-so": {
    language: "Arabic",
    location: "Somalia",
    id: 4096,
    tag: "ar-SO",
  },
  "ar-ss": {
    language: "Arabic",
    location: "South Sudan",
    id: 4096,
    tag: "ar-SS",
  },
  "ar-sd": {
    language: "Arabic",
    location: "Sudan",
    id: 4096,
    tag: "ar-SD",
  },
  "ar-sy": {
    language: "Arabic",
    location: "Syria",
    id: 10241,
    tag: "ar-SY",
  },
  "ar-tn": {
    language: "Arabic",
    location: "Tunisia",
    id: 7169,
    tag: "ar-TN",
  },
  "ar-ae": {
    language: "Arabic",
    location: "U.A.E.",
    id: 14337,
    tag: "ar-AE",
  },
  "ar-001": {
    language: "Arabic",
    location: "World",
    id: 4096,
    tag: "ar-001",
  },
  "ar-ye": {
    language: "Arabic",
    location: "Yemen",
    id: 9217,
    tag: "ar-YE",
  },
  hy: {
    language: "Armenian",
    location: null,
    id: 43,
    tag: "hy",
  },
  "hy-am": {
    language: "Armenian",
    location: "Armenia",
    id: 1067,
    tag: "hy-AM",
  },
  as: {
    language: "Assamese",
    location: null,
    id: 77,
    tag: "as",
  },
  "as-in": {
    language: "Assamese",
    location: "India",
    id: 1101,
    tag: "as-IN",
  },
  ast: {
    language: "Asturian",
    location: null,
    id: 4096,
    tag: "ast",
  },
  "ast-es": {
    language: "Asturian",
    location: "Spain",
    id: 4096,
    tag: "ast-ES",
  },
  asa: {
    language: "Asu",
    location: null,
    id: 4096,
    tag: "asa",
  },
  "asa-tz": {
    language: "Asu",
    location: "Tanzania",
    id: 4096,
    tag: "asa-TZ",
  },
  "az-cyrl": {
    language: "Azerbaijani (Cyrillic)",
    location: null,
    id: 29740,
    tag: "az-Cyrl",
    version: "Windows 7",
  },
  "az-cyrl-az": {
    language: "Azerbaijani (Cyrillic)",
    location: "Azerbaijan",
    id: 2092,
    tag: "az-Cyrl-AZ",
  },
  az: {
    language: "Azerbaijani (Latin)",
    location: null,
    id: 44,
    tag: "az",
  },
  "az-latn": {
    language: "Azerbaijani (Latin)",
    location: null,
    id: 30764,
    tag: "az-Latn",
    version: "Windows 7",
  },
  "az-latn-az": {
    language: "Azerbaijani (Latin)",
    location: "Azerbaijan",
    id: 1068,
    tag: "az-Latn-AZ",
  },
  ksf: {
    language: "Bafia",
    location: null,
    id: 4096,
    tag: "ksf",
  },
  "ksf-cm": {
    language: "Bafia",
    location: "Cameroon",
    id: 4096,
    tag: "ksf-CM",
  },
  bm: {
    language: "Bamanankan",
    location: null,
    id: 4096,
    tag: "bm",
  },
  "bm-latn-ml": {
    language: "Bamanankan (Latin)",
    location: "Mali",
    id: 4096,
    tag: "bm-Latn-ML",
  },
  bn: {
    language: "Bangla",
    location: null,
    id: 69,
    tag: "bn",
  },
  "bn-bd": {
    language: "Bangla",
    location: "Bangladesh",
    id: 2117,
    tag: "bn-BD",
  },
  "bn-in": {
    language: "Bangla",
    location: "India",
    id: 1093,
    tag: "bn-IN",
  },
  bas: {
    language: "Basaa",
    location: null,
    id: 4096,
    tag: "bas",
  },
  "bas-cm": {
    language: "Basaa",
    location: "Cameroon",
    id: 4096,
    tag: "bas-CM",
  },
  ba: {
    language: "Bashkir",
    location: null,
    id: 109,
    tag: "ba",
  },
  "ba-ru": {
    language: "Bashkir",
    location: "Russia",
    id: 1133,
    tag: "ba-RU",
  },
  eu: {
    language: "Basque",
    location: null,
    id: 45,
    tag: "eu",
  },
  "eu-es": {
    language: "Basque",
    location: "Spain",
    id: 1069,
    tag: "eu-ES",
  },
  be: {
    language: "Belarusian",
    location: null,
    id: 35,
    tag: "be",
  },
  "be-by": {
    language: "Belarusian",
    location: "Belarus",
    id: 1059,
    tag: "be-BY",
  },
  bem: {
    language: "Bemba",
    location: null,
    id: 4096,
    tag: "bem",
  },
  "bem-zm": {
    language: "Bemba",
    location: "Zambia",
    id: 4096,
    tag: "bem-ZM",
  },
  bez: {
    language: "Bena",
    location: null,
    id: 4096,
    tag: "bez",
  },
  "bez-tz": {
    language: "Bena",
    location: "Tanzania",
    id: 4096,
    tag: "bez-TZ",
  },
  byn: {
    language: "Blin",
    location: null,
    id: 4096,
    tag: "byn",
  },
  "byn-er": {
    language: "Blin",
    location: "Eritrea",
    id: 4096,
    tag: "byn-ER",
  },
  brx: {
    language: "Bodo",
    location: null,
    id: 4096,
    tag: "brx",
  },
  "brx-in": {
    language: "Bodo",
    location: "India",
    id: 4096,
    tag: "brx-IN",
  },
  "bs-cyrl": {
    language: "Bosnian (Cyrillic)",
    location: null,
    id: 25626,
    tag: "bs-Cyrl",
    version: "Windows 7",
  },
  "bs-cyrl-ba": {
    language: "Bosnian (Cyrillic)",
    location: "Bosnia and Herzegovina",
    id: 8218,
    tag: "bs-Cyrl-BA",
  },
  "bs-latn": {
    language: "Bosnian (Latin)",
    location: null,
    id: 26650,
    tag: "bs-Latn",
    version: "Windows 7",
  },
  bs: {
    language: "Bosnian (Latin)",
    location: null,
    id: 30746,
    tag: "bs",
  },
  "bs-latn-ba": {
    language: "Bosnian (Latin)",
    location: "Bosnia and Herzegovina",
    id: 5146,
    tag: "bs-Latn-BA",
  },
  br: {
    language: "Breton",
    location: null,
    id: 126,
    tag: "br",
  },
  "br-fr": {
    language: "Breton",
    location: "France",
    id: 1150,
    tag: "br-FR",
  },
  bg: {
    language: "Bulgarian",
    location: null,
    id: 2,
    tag: "bg",
  },
  "bg-bg": {
    language: "Bulgarian",
    location: "Bulgaria",
    id: 1026,
    tag: "bg-BG",
  },
  my: {
    language: "Burmese",
    location: null,
    id: 85,
    tag: "my",
  },
  "my-mm": {
    language: "Burmese",
    location: "Myanmar",
    id: 1109,
    tag: "my-MM",
  },
  ca: {
    language: "Catalan",
    location: null,
    id: 3,
    tag: "ca",
  },
  "ca-ad": {
    language: "Catalan",
    location: "Andorra",
    id: 4096,
    tag: "ca-AD",
  },
  "ca-fr": {
    language: "Catalan",
    location: "France",
    id: 4096,
    tag: "ca-FR",
  },
  "ca-it": {
    language: "Catalan",
    location: "Italy",
    id: 4096,
    tag: "ca-IT",
  },
  "ca-es": {
    language: "Catalan",
    location: "Spain",
    id: 1027,
    tag: "ca-ES",
  },
  ceb: {
    language: "Cebuano",
    location: null,
    id: 4096,
    tag: "ceb",
  },
  "ceb-latn": {
    language: "Cebuan (Latin)",
    location: null,
    id: 4096,
    tag: "ceb-Latn",
  },
  "ceb-latn-ph": {
    language: "Cebuan (Latin)",
    location: "Philippines",
    id: 4096,
    tag: "ceb-Latn-PH",
  },
  "tzm-latn-": {
    language: "Central Atlas Tamazight (Latin)",
    location: "Morocco",
    id: 4096,
    tag: "tzm-Latn-",
  },
  ku: {
    language: "Central Kurdish",
    location: null,
    id: 146,
    tag: "ku",
  },
  "ku-arab": {
    language: "Central Kurdish",
    location: null,
    id: 31890,
    tag: "ku-Arab",
  },
  "ku-arab-iq": {
    language: "Central Kurdish",
    location: "Iraq",
    id: 1170,
    tag: "ku-Arab-IQ",
  },
  ccp: {
    language: "Chakma",
    location: null,
    id: 4096,
    tag: "ccp",
  },
  "ccp-cakm": {
    language: "Chakma",
    location: "Chakma",
    id: 4096,
    tag: "ccp-Cakm",
  },
  "ccp-cakm-": {
    language: "Chakma",
    location: "India",
    id: 4096,
    tag: "ccp-Cakm-",
  },
  "cd-ru": {
    language: "Chechen",
    location: "Russia",
    id: 4096,
    tag: "cd-RU",
  },
  chr: {
    language: "Cherokee",
    location: null,
    id: 92,
    tag: "chr",
  },
  "chr-cher": {
    language: "Cherokee",
    location: null,
    id: 31836,
    tag: "chr-Cher",
  },
  "chr-cher-us": {
    language: "Cherokee",
    location: "United States",
    id: 1116,
    tag: "chr-Cher-US",
  },
  cgg: {
    language: "Chiga",
    location: null,
    id: 4096,
    tag: "cgg",
  },
  "cgg-ug": {
    language: "Chiga",
    location: "Uganda",
    id: 4096,
    tag: "cgg-UG",
  },
  "zh-hans": {
    language: "Chinese (Simplified)",
    location: null,
    id: 4,
    tag: "zh-Hans",
  },
  zh: {
    language: "Chinese (Simplified)",
    location: null,
    id: 30724,
    tag: "zh",
    version: "Windows 7",
  },
  "zh-cn": {
    language: "Chinese (Simplified)",
    location: "People's Republic of China",
    id: 2052,
    tag: "zh-CN",
  },
  "zh-sg": {
    language: "Chinese (Simplified)",
    location: "Singapore",
    id: 4100,
    tag: "zh-SG",
  },
  "zh-hant": {
    language: "Chinese (Traditional)",
    location: null,
    id: 31748,
    tag: "zh-Hant",
  },
  "zh-hk": {
    language: "Chinese (Traditional)",
    location: "Hong Kong S.A.R.",
    id: 3076,
    tag: "zh-HK",
  },
  "zh-mo": {
    language: "Chinese (Traditional)",
    location: "Macao S.A.R.",
    id: 5124,
    tag: "zh-MO",
  },
  "zh-tw": {
    language: "Chinese (Traditional)",
    location: "Taiwan",
    id: 1028,
    tag: "zh-TW",
  },
  "cu-ru": {
    language: "Church Slavic",
    location: "Russia",
    id: 4096,
    tag: "cu-RU",
  },
  swc: {
    language: "Congo Swahili",
    location: null,
    id: 4096,
    tag: "swc",
  },
  "swc-cd": {
    language: "Congo Swahili",
    location: "Congo DRC",
    id: 4096,
    tag: "swc-CD",
  },
  kw: {
    language: "Cornish",
    location: null,
    id: 4096,
    tag: "kw",
  },
  "kw-gb": {
    language: "Cornish",
    location: "United Kingdom",
    id: 4096,
    tag: "kw-GB",
  },
  co: {
    language: "Corsican",
    location: null,
    id: 131,
    tag: "co",
  },
  "co-fr": {
    language: "Corsican",
    location: "France",
    id: 1155,
    tag: "co-FR",
  },
  hr: {
    language: "Croatian",
    location: null,
    id: 26,
    tag: "hr",
  },
  "hr-hr": {
    language: "Croatian",
    location: "Croatia",
    id: 1050,
    tag: "hr-HR",
  },
  "hr-ba": {
    language: "Croatian (Latin)",
    location: "Bosnia and Herzegovina",
    id: 4122,
    tag: "hr-BA",
  },
  cs: {
    language: "Czech",
    location: null,
    id: 5,
    tag: "cs",
  },
  "cs-cz": {
    language: "Czech",
    location: "Czech Republic",
    id: 1029,
    tag: "cs-CZ",
  },
  da: {
    language: "Danish",
    location: null,
    id: 6,
    tag: "da",
  },
  "da-dk": {
    language: "Danish",
    location: "Denmark",
    id: 1030,
    tag: "da-DK",
  },
  "da-gl": {
    language: "Danish",
    location: "Greenland",
    id: 4096,
    tag: "da-GL",
  },
  prs: {
    language: "Dari",
    location: null,
    id: 140,
    tag: "prs",
  },
  "prs-af": {
    language: "Dari",
    location: "Afghanistan",
    id: 1164,
    tag: "prs-AF",
  },
  dv: {
    language: "Divehi",
    location: null,
    id: 101,
    tag: "dv",
  },
  "dv-mv": {
    language: "Divehi",
    location: "Maldives",
    id: 1125,
    tag: "dv-MV",
  },
  dua: {
    language: "Duala",
    location: null,
    id: 4096,
    tag: "dua",
  },
  "dua-cm": {
    language: "Duala",
    location: "Cameroon",
    id: 4096,
    tag: "dua-CM",
  },
  nl: {
    language: "Dutch",
    location: null,
    id: 19,
    tag: "nl",
  },
  "nl-aw": {
    language: "Dutch",
    location: "Aruba",
    id: 4096,
    tag: "nl-AW",
  },
  "nl-be": {
    language: "Dutch",
    location: "Belgium",
    id: 2067,
    tag: "nl-BE",
  },
  "nl-bq": {
    language: "Dutch",
    location: "Bonaire, Sint Eustatius and Saba",
    id: 4096,
    tag: "nl-BQ",
  },
  "nl-cw": {
    language: "Dutch",
    location: "Curaçao",
    id: 4096,
    tag: "nl-CW",
  },
  "nl-nl": {
    language: "Dutch",
    location: "Netherlands",
    id: 1043,
    tag: "nl-NL",
  },
  "nl-sx": {
    language: "Dutch",
    location: "Sint Maarten",
    id: 4096,
    tag: "nl-SX",
  },
  "nl-sr": {
    language: "Dutch",
    location: "Suriname",
    id: 4096,
    tag: "nl-SR",
  },
  dz: {
    language: "Dzongkha",
    location: null,
    id: 4096,
    tag: "dz",
  },
  "dz-bt": {
    language: "Dzongkha",
    location: "Bhutan",
    id: 3153,
    tag: "dz-BT",
  },
  ebu: {
    language: "Embu",
    location: null,
    id: 4096,
    tag: "ebu",
  },
  "ebu-ke": {
    language: "Embu",
    location: "Kenya",
    id: 4096,
    tag: "ebu-KE",
  },
  en: {
    language: "English",
    location: null,
    id: 9,
    tag: "en",
  },
  "en-as": {
    language: "English",
    location: "American Samoa",
    id: 4096,
    tag: "en-AS",
  },
  "en-ai": {
    language: "English",
    location: "Anguilla",
    id: 4096,
    tag: "en-AI",
  },
  "en-ag": {
    language: "English",
    location: "Antigua and Barbuda",
    id: 4096,
    tag: "en-AG",
  },
  "en-au": {
    language: "English",
    location: "Australia",
    id: 3081,
    tag: "en-AU",
  },
  "en-at": {
    language: "English",
    location: "Austria",
    id: 4096,
    tag: "en-AT",
  },
  "en-bs": {
    language: "English",
    location: "Bahamas",
    id: 4096,
    tag: "en-BS",
  },
  "en-bb": {
    language: "English",
    location: "Barbados",
    id: 4096,
    tag: "en-BB",
  },
  "en-be": {
    language: "English",
    location: "Belgium",
    id: 4096,
    tag: "en-BE",
  },
  "en-bz": {
    language: "English",
    location: "Belize",
    id: 10249,
    tag: "en-BZ",
  },
  "en-bm": {
    language: "English",
    location: "Bermuda",
    id: 4096,
    tag: "en-BM",
  },
  "en-bw": {
    language: "English",
    location: "Botswana",
    id: 4096,
    tag: "en-BW",
  },
  "en-io": {
    language: "English",
    location: "British Indian Ocean Territory",
    id: 4096,
    tag: "en-IO",
  },
  "en-vg": {
    language: "English",
    location: "British Virgin Islands",
    id: 4096,
    tag: "en-VG",
  },
  "en-bi": {
    language: "English",
    location: "Burundi",
    id: 4096,
    tag: "en-BI",
  },
  "en-cm": {
    language: "English",
    location: "Cameroon",
    id: 4096,
    tag: "en-CM",
  },
  "en-ca": {
    language: "English",
    location: "Canada",
    id: 4105,
    tag: "en-CA",
  },
  "en-029": {
    language: "English",
    location: "Caribbean",
    id: 9225,
    tag: "en-029",
  },
  "en-ky": {
    language: "English",
    location: "Cayman Islands",
    id: 4096,
    tag: "en-KY",
  },
  "en-cx": {
    language: "English",
    location: "Christmas Island",
    id: 4096,
    tag: "en-CX",
  },
  "en-cc": {
    language: "English",
    location: "Cocos [Keeling] Islands",
    id: 4096,
    tag: "en-CC",
  },
  "en-ck": {
    language: "English",
    location: "Cook Islands",
    id: 4096,
    tag: "en-CK",
  },
  "en-cy": {
    language: "English",
    location: "Cyprus",
    id: 4096,
    tag: "en-CY",
  },
  "en-dk": {
    language: "English",
    location: "Denmark",
    id: 4096,
    tag: "en-DK",
  },
  "en-dm": {
    language: "English",
    location: "Dominica",
    id: 4096,
    tag: "en-DM",
  },
  "en-er": {
    language: "English",
    location: "Eritrea",
    id: 4096,
    tag: "en-ER",
  },
  "en-150": {
    language: "English",
    location: "Europe",
    id: 4096,
    tag: "en-150",
  },
  "en-fk": {
    language: "English",
    location: "Falkland Islands",
    id: 4096,
    tag: "en-FK",
  },
  "en-fi": {
    language: "English",
    location: "Finland",
    id: 4096,
    tag: "en-FI",
  },
  "en-fj": {
    language: "English",
    location: "Fiji",
    id: 4096,
    tag: "en-FJ",
  },
  "en-gm": {
    language: "English",
    location: "Gambia",
    id: 4096,
    tag: "en-GM",
  },
  "en-de": {
    language: "English",
    location: "Germany",
    id: 4096,
    tag: "en-DE",
  },
  "en-gh": {
    language: "English",
    location: "Ghana",
    id: 4096,
    tag: "en-GH",
  },
  "en-gi": {
    language: "English",
    location: "Gibraltar",
    id: 4096,
    tag: "en-GI",
  },
  "en-gd": {
    language: "English",
    location: "Grenada",
    id: 4096,
    tag: "en-GD",
  },
  "en-gu": {
    language: "English",
    location: "Guam",
    id: 4096,
    tag: "en-GU",
  },
  "en-gg": {
    language: "English",
    location: "Guernsey",
    id: 4096,
    tag: "en-GG",
  },
  "en-gy": {
    language: "English",
    location: "Guyana",
    id: 4096,
    tag: "en-GY",
  },
  "en-hk": {
    language: "English",
    location: "Hong Kong",
    id: 15369,
    tag: "en-HK",
  },
  "en-in": {
    language: "English",
    location: "India",
    id: 16393,
    tag: "en-IN",
  },
  "en-ie": {
    language: "English",
    location: "Ireland",
    id: 6153,
    tag: "en-IE",
  },
  "en-im": {
    language: "English",
    location: "Isle of Man",
    id: 4096,
    tag: "en-IM",
  },
  "en-il": {
    language: "English",
    location: "Israel",
    id: 4096,
    tag: "en-IL",
  },
  "en-jm": {
    language: "English",
    location: "Jamaica",
    id: 8201,
    tag: "en-JM",
  },
  "en-je": {
    language: "English",
    location: "Jersey",
    id: 4096,
    tag: "en-JE",
  },
  "en-ke": {
    language: "English",
    location: "Kenya",
    id: 4096,
    tag: "en-KE",
  },
  "en-ki": {
    language: "English",
    location: "Kiribati",
    id: 4096,
    tag: "en-KI",
  },
  "en-ls": {
    language: "English",
    location: "Lesotho",
    id: 4096,
    tag: "en-LS",
  },
  "en-lr": {
    language: "English",
    location: "Liberia",
    id: 4096,
    tag: "en-LR",
  },
  "en-mo": {
    language: "English",
    location: "Macao SAR",
    id: 4096,
    tag: "en-MO",
  },
  "en-mg": {
    language: "English",
    location: "Madagascar",
    id: 4096,
    tag: "en-MG",
  },
  "en-mw": {
    language: "English",
    location: "Malawi",
    id: 4096,
    tag: "en-MW",
  },
  "en-my": {
    language: "English",
    location: "Malaysia",
    id: 17417,
    tag: "en-MY",
  },
  "en-mt": {
    language: "English",
    location: "Malta",
    id: 4096,
    tag: "en-MT",
  },
  "en-mh": {
    language: "English",
    location: "Marshall Islands",
    id: 4096,
    tag: "en-MH",
  },
  "en-mu": {
    language: "English",
    location: "Mauritius",
    id: 4096,
    tag: "en-MU",
  },
  "en-fm": {
    language: "English",
    location: "Micronesia",
    id: 4096,
    tag: "en-FM",
  },
  "en-ms": {
    language: "English",
    location: "Montserrat",
    id: 4096,
    tag: "en-MS",
  },
  "en-na": {
    language: "English",
    location: "Namibia",
    id: 4096,
    tag: "en-NA",
  },
  "en-nr": {
    language: "English",
    location: "Nauru",
    id: 4096,
    tag: "en-NR",
  },
  "en-nl": {
    language: "English",
    location: "Netherlands",
    id: 4096,
    tag: "en-NL",
  },
  "en-nz": {
    language: "English",
    location: "New Zealand",
    id: 5129,
    tag: "en-NZ",
  },
  "en-ng": {
    language: "English",
    location: "Nigeria",
    id: 4096,
    tag: "en-NG",
  },
  "en-nu": {
    language: "English",
    location: "Niue",
    id: 4096,
    tag: "en-NU",
  },
  "en-nf": {
    language: "English",
    location: "Norfolk Island",
    id: 4096,
    tag: "en-NF",
  },
  "en-mp": {
    language: "English",
    location: "Northern Mariana Islands",
    id: 4096,
    tag: "en-MP",
  },
  "en-pk": {
    language: "English",
    location: "Pakistan",
    id: 4096,
    tag: "en-PK",
  },
  "en-pw": {
    language: "English",
    location: "Palau",
    id: 4096,
    tag: "en-PW",
  },
  "en-pg": {
    language: "English",
    location: "Papua New Guinea",
    id: 4096,
    tag: "en-PG",
  },
  "en-pn": {
    language: "English",
    location: "Pitcairn Islands",
    id: 4096,
    tag: "en-PN",
  },
  "en-pr": {
    language: "English",
    location: "Puerto Rico",
    id: 4096,
    tag: "en-PR",
  },
  "en-ph": {
    language: "English",
    location: "Republic of the Philippines",
    id: 13321,
    tag: "en-PH",
  },
  "en-rw": {
    language: "English",
    location: "Rwanda",
    id: 4096,
    tag: "en-RW",
  },
  "en-kn": {
    language: "English",
    location: "Saint Kitts and Nevis",
    id: 4096,
    tag: "en-KN",
  },
  "en-lc": {
    language: "English",
    location: "Saint Lucia",
    id: 4096,
    tag: "en-LC",
  },
  "en-vc": {
    language: "English",
    location: "Saint Vincent and the Grenadines",
    id: 4096,
    tag: "en-VC",
  },
  "en-ws": {
    language: "English",
    location: "Samoa",
    id: 4096,
    tag: "en-WS",
  },
  "en-sc": {
    language: "English",
    location: "Seychelles",
    id: 4096,
    tag: "en-SC",
  },
  "en-sl": {
    language: "English",
    location: "Sierra Leone",
    id: 4096,
    tag: "en-SL",
  },
  "en-sg": {
    language: "English",
    location: "Singapore",
    id: 18441,
    tag: "en-SG",
  },
  "en-sx": {
    language: "English",
    location: "Sint Maarten",
    id: 4096,
    tag: "en-SX",
  },
  "en-si": {
    language: "English",
    location: "Slovenia",
    id: 4096,
    tag: "en-SI",
  },
  "en-sb": {
    language: "English",
    location: "Solomon Islands",
    id: 4096,
    tag: "en-SB",
  },
  "en-za": {
    language: "English",
    location: "South Africa",
    id: 7177,
    tag: "en-ZA",
  },
  "en-ss": {
    language: "English",
    location: "South Sudan",
    id: 4096,
    tag: "en-SS",
  },
  "en-sh": {
    language: "English",
    location: "St Helena, Ascension,  Tristan da Cunha",
    id: 4096,
    tag: "en-SH",
  },
  "en-sd": {
    language: "English",
    location: "Sudan",
    id: 4096,
    tag: "en-SD",
  },
  "en-sz": {
    language: "English",
    location: "Swaziland",
    id: 4096,
    tag: "en-SZ",
  },
  "en-se": {
    language: "English",
    location: "Sweden",
    id: 4096,
    tag: "en-SE",
  },
  "en-ch": {
    language: "English",
    location: "Switzerland",
    id: 4096,
    tag: "en-CH",
  },
  "en-tz": {
    language: "English",
    location: "Tanzania",
    id: 4096,
    tag: "en-TZ",
  },
  "en-tk": {
    language: "English",
    location: "Tokelau",
    id: 4096,
    tag: "en-TK",
  },
  "en-to": {
    language: "English",
    location: "Tonga",
    id: 4096,
    tag: "en-TO",
  },
  "en-tt": {
    language: "English",
    location: "Trinidad and Tobago",
    id: 11273,
    tag: "en-TT",
  },
  "en-tc": {
    language: "English",
    location: "Turks and Caicos Islands",
    id: 4096,
    tag: "en-TC",
  },
  "en-tv": {
    language: "English",
    location: "Tuvalu",
    id: 4096,
    tag: "en-TV",
  },
  "en-ug": {
    language: "English",
    location: "Uganda",
    id: 4096,
    tag: "en-UG",
  },
  "en-ae": {
    language: "English",
    location: "United Arab Emirates",
    id: 19465,
    tag: "en-AE",
  },
  "en-gb": {
    language: "English",
    location: "United Kingdom",
    id: 2057,
    tag: "en-GB",
  },
  "en-us": {
    language: "English",
    location: "United States",
    id: 1033,
    tag: "en-US",
  },
  "en-um": {
    language: "English",
    location: "US Minor Outlying Islands",
    id: 4096,
    tag: "en-UM",
  },
  "en-vi": {
    language: "English",
    location: "US Virgin Islands",
    id: 4096,
    tag: "en-VI",
  },
  "en-vu": {
    language: "English",
    location: "Vanuatu",
    id: 4096,
    tag: "en-VU",
  },
  "en-001": {
    language: "English",
    location: "World",
    id: 4096,
    tag: "en-001",
  },
  "en-zm": {
    language: "English",
    location: "Zambia",
    id: 4096,
    tag: "en-ZM",
  },
  "en-zw": {
    language: "English",
    location: "Zimbabwe",
    id: 12297,
    tag: "en-ZW",
  },
  eo: {
    language: "Esperanto",
    location: null,
    id: 4096,
    tag: "eo",
  },
  "eo-001": {
    language: "Esperanto",
    location: "World",
    id: 4096,
    tag: "eo-001",
  },
  et: {
    language: "Estonian",
    location: null,
    id: 37,
    tag: "et",
  },
  "et-ee": {
    language: "Estonian",
    location: "Estonia",
    id: 1061,
    tag: "et-EE",
  },
  ee: {
    language: "Ewe",
    location: null,
    id: 4096,
    tag: "ee",
  },
  "ee-gh": {
    language: "Ewe",
    location: "Ghana",
    id: 4096,
    tag: "ee-GH",
  },
  "ee-tg": {
    language: "Ewe",
    location: "Togo",
    id: 4096,
    tag: "ee-TG",
  },
  ewo: {
    language: "Ewondo",
    location: null,
    id: 4096,
    tag: "ewo",
  },
  "ewo-cm": {
    language: "Ewondo",
    location: "Cameroon",
    id: 4096,
    tag: "ewo-CM",
  },
  fo: {
    language: "Faroese",
    location: null,
    id: 56,
    tag: "fo",
  },
  "fo-dk": {
    language: "Faroese",
    location: "Denmark",
    id: 4096,
    tag: "fo-DK",
  },
  "fo-fo": {
    language: "Faroese",
    location: "Faroe Islands",
    id: 1080,
    tag: "fo-FO",
  },
  fil: {
    language: "Filipino",
    location: null,
    id: 100,
    tag: "fil",
  },
  "fil-ph": {
    language: "Filipino",
    location: "Philippines",
    id: 1124,
    tag: "fil-PH",
  },
  fi: {
    language: "Finnish",
    location: null,
    id: 11,
    tag: "fi",
  },
  "fi-fi": {
    language: "Finnish",
    location: "Finland",
    id: 1035,
    tag: "fi-FI",
  },
  fr: {
    language: "French",
    location: null,
    id: 12,
    tag: "fr",
  },
  "fr-dz": {
    language: "French",
    location: "Algeria",
    id: 4096,
    tag: "fr-DZ",
  },
  "fr-be": {
    language: "French",
    location: "Belgium",
    id: 2060,
    tag: "fr-BE",
  },
  "fr-bj": {
    language: "French",
    location: "Benin",
    id: 4096,
    tag: "fr-BJ",
  },
  "fr-bf": {
    language: "French",
    location: "Burkina Faso",
    id: 4096,
    tag: "fr-BF",
  },
  "fr-bi": {
    language: "French",
    location: "Burundi",
    id: 4096,
    tag: "fr-BI",
  },
  "fr-cm": {
    language: "French",
    location: "Cameroon",
    id: 11276,
    tag: "fr-CM",
  },
  "fr-ca": {
    language: "French",
    location: "Canada",
    id: 3084,
    tag: "fr-CA",
  },
  "fr-cf": {
    language: "French",
    location: "Central African Republic",
    id: 4096,
    tag: "fr-CF",
    version: "Release10",
  },
  "fr-td": {
    language: "French",
    location: "Chad",
    id: 4096,
    tag: "fr-TD",
  },
  "fr-km": {
    language: "French",
    location: "Comoros",
    id: 4096,
    tag: "fr-KM",
  },
  "fr-cg": {
    language: "French",
    location: "Congo",
    id: 4096,
    tag: "fr-CG",
  },
  "fr-cd": {
    language: "French",
    location: "Congo, DRC",
    id: 9228,
    tag: "fr-CD",
  },
  "fr-ci": {
    language: "French",
    location: "Côte d'Ivoire",
    id: 12300,
    tag: "fr-CI",
  },
  "fr-dj": {
    language: "French",
    location: "Djibouti",
    id: 4096,
    tag: "fr-DJ",
  },
  "fr-gq": {
    language: "French",
    location: "Equatorial Guinea",
    id: 4096,
    tag: "fr-GQ",
  },
  "fr-fr": {
    language: "French",
    location: "France",
    id: 1036,
    tag: "fr-FR",
  },
  "fr-gf": {
    language: "French",
    location: "French Guiana",
    id: 4096,
    tag: "fr-GF",
  },
  "fr-pf": {
    language: "French",
    location: "French Polynesia",
    id: 4096,
    tag: "fr-PF",
  },
  "fr-ga": {
    language: "French",
    location: "Gabon",
    id: 4096,
    tag: "fr-GA",
  },
  "fr-gp": {
    language: "French",
    location: "Guadeloupe",
    id: 4096,
    tag: "fr-GP",
  },
  "fr-gn": {
    language: "French",
    location: "Guinea",
    id: 4096,
    tag: "fr-GN",
  },
  "fr-ht": {
    language: "French",
    location: "Haiti",
    id: 15372,
    tag: "fr-HT",
  },
  "fr-lu": {
    language: "French",
    location: "Luxembourg",
    id: 5132,
    tag: "fr-LU",
  },
  "fr-mg": {
    language: "French",
    location: "Madagascar",
    id: 4096,
    tag: "fr-MG",
  },
  "fr-ml": {
    language: "French",
    location: "Mali",
    id: 13324,
    tag: "fr-ML",
  },
  "fr-mq": {
    language: "French",
    location: "Martinique",
    id: 4096,
    tag: "fr-MQ",
  },
  "fr-mr": {
    language: "French",
    location: "Mauritania",
    id: 4096,
    tag: "fr-MR",
  },
  "fr-mu": {
    language: "French",
    location: "Mauritius",
    id: 4096,
    tag: "fr-MU",
  },
  "fr-yt": {
    language: "French",
    location: "Mayotte",
    id: 4096,
    tag: "fr-YT",
  },
  "fr-ma": {
    language: "French",
    location: "Morocco",
    id: 14348,
    tag: "fr-MA",
  },
  "fr-nc": {
    language: "French",
    location: "New Caledonia",
    id: 4096,
    tag: "fr-NC",
  },
  "fr-ne": {
    language: "French",
    location: "Niger",
    id: 4096,
    tag: "fr-NE",
  },
  "fr-mc": {
    language: "French",
    location: "Principality of Monaco",
    id: 6156,
    tag: "fr-MC",
  },
  "fr-re": {
    language: "French",
    location: "Reunion",
    id: 8204,
    tag: "fr-RE",
  },
  "fr-rw": {
    language: "French",
    location: "Rwanda",
    id: 4096,
    tag: "fr-RW",
  },
  "fr-bl": {
    language: "French",
    location: "Saint Barthélemy",
    id: 4096,
    tag: "fr-BL",
  },
  "fr-mf": {
    language: "French",
    location: "Saint Martin",
    id: 4096,
    tag: "fr-MF",
  },
  "fr-pm": {
    language: "French",
    location: "Saint Pierre and Miquelon",
    id: 4096,
    tag: "fr-PM",
  },
  "fr-sn": {
    language: "French",
    location: "Senegal",
    id: 10252,
    tag: "fr-SN",
  },
  "fr-sc": {
    language: "French",
    location: "Seychelles",
    id: 4096,
    tag: "fr-SC",
  },
  "fr-ch": {
    language: "French",
    location: "Switzerland",
    id: 4108,
    tag: "fr-CH",
  },
  "fr-sy": {
    language: "French",
    location: "Syria",
    id: 4096,
    tag: "fr-SY",
  },
  "fr-tg": {
    language: "French",
    location: "Togo",
    id: 4096,
    tag: "fr-TG",
  },
  "fr-tn": {
    language: "French",
    location: "Tunisia",
    id: 4096,
    tag: "fr-TN",
  },
  "fr-vu": {
    language: "French",
    location: "Vanuatu",
    id: 4096,
    tag: "fr-VU",
  },
  "fr-wf": {
    language: "French",
    location: "Wallis and Futuna",
    id: 4096,
    tag: "fr-WF",
  },
  fy: {
    language: "Frisian",
    location: null,
    id: 98,
    tag: "fy",
  },
  "fy-nl": {
    language: "Frisian",
    location: "Netherlands",
    id: 1122,
    tag: "fy-NL",
  },
  fur: {
    language: "Friulian",
    location: null,
    id: 4096,
    tag: "fur",
  },
  "fur-it": {
    language: "Friulian",
    location: "Italy",
    id: 4096,
    tag: "fur-IT",
  },
  ff: {
    language: "Fulah",
    location: null,
    id: 103,
    tag: "ff",
  },
  "ff-latn": {
    language: "Fulah (Latin)",
    location: null,
    id: 31847,
    tag: "ff-Latn",
  },
  "ff-latn-bf": {
    language: "Fulah (Latin)",
    location: "Burkina Faso",
    id: 4096,
    tag: "ff-Latn-BF",
  },
  "ff-cm": {
    language: "Fulah",
    location: "Cameroon",
    id: 4096,
    tag: "ff-CM",
  },
  "ff-latn-cm": {
    language: "Fulah (Latin)",
    location: "Cameroon",
    id: 4096,
    tag: "ff-Latn-CM",
  },
  "ff-latn-gm": {
    language: "Fulah (Latin)",
    location: "Gambia",
    id: 4096,
    tag: "ff-Latn-GM",
  },
  "ff-latn-gh": {
    language: "Fulah (Latin)",
    location: "Ghana",
    id: 4096,
    tag: "ff-Latn-GH",
  },
  "ff-gn": {
    language: "Fulah",
    location: "Guinea",
    id: 4096,
    tag: "ff-GN",
  },
  "ff-latn-gn": {
    language: "Fulah (Latin)",
    location: "Guinea",
    id: 4096,
    tag: "ff-Latn-GN",
  },
  "ff-latn-gw": {
    language: "Fulah (Latin)",
    location: "Guinea-Bissau",
    id: 4096,
    tag: "ff-Latn-GW",
  },
  "ff-latn-lr": {
    language: "Fulah (Latin)",
    location: "Liberia",
    id: 4096,
    tag: "ff-Latn-LR",
  },
  "ff-mr": {
    language: "Fulah",
    location: "Mauritania",
    id: 4096,
    tag: "ff-MR",
  },
  "ff-latn-mr": {
    language: "Fulah (Latin)",
    location: "Mauritania",
    id: 4096,
    tag: "ff-Latn-MR",
  },
  "ff-latn-ne": {
    language: "Fulah (Latin)",
    location: "Niger",
    id: 4096,
    tag: "ff-Latn-NE",
  },
  "ff-ng": {
    language: "Fulah",
    location: "Nigeria",
    id: 4096,
    tag: "ff-NG",
  },
  "ff-latn-ng": {
    language: "Fulah (Latin)",
    location: "Nigeria",
    id: 4096,
    tag: "ff-Latn-NG",
  },
  "ff-latn-sn": {
    language: "Fulah",
    location: "Senegal",
    id: 2151,
    tag: "ff-Latn-SN",
  },
  "ff-latn-sl": {
    language: "Fulah (Latin)",
    location: "Sierra Leone",
    id: 4096,
    tag: "ff-Latn-SL",
  },
  gl: {
    language: "Galician",
    location: null,
    id: 86,
    tag: "gl",
  },
  "gl-es": {
    language: "Galician",
    location: "Spain",
    id: 1110,
    tag: "gl-ES",
  },
  lg: {
    language: "Ganda",
    location: null,
    id: 4096,
    tag: "lg",
  },
  "lg-ug": {
    language: "Ganda",
    location: "Uganda",
    id: 4096,
    tag: "lg-UG",
  },
  ka: {
    language: "Georgian",
    location: null,
    id: 55,
    tag: "ka",
  },
  "ka-ge": {
    language: "Georgian",
    location: "Georgia",
    id: 1079,
    tag: "ka-GE",
  },
  de: {
    language: "German",
    location: null,
    id: 7,
    tag: "de",
  },
  "de-at": {
    language: "German",
    location: "Austria",
    id: 3079,
    tag: "de-AT",
  },
  "de-be": {
    language: "German",
    location: "Belgium",
    id: 4096,
    tag: "de-BE",
  },
  "de-de": {
    language: "German",
    location: "Germany",
    id: 1031,
    tag: "de-DE",
  },
  "de-it": {
    language: "German",
    location: "Italy",
    id: 4096,
    tag: "de-IT",
  },
  "de-li": {
    language: "German",
    location: "Liechtenstein",
    id: 5127,
    tag: "de-LI",
  },
  "de-lu": {
    language: "German",
    location: "Luxembourg",
    id: 4103,
    tag: "de-LU",
  },
  "de-ch": {
    language: "German",
    location: "Switzerland",
    id: 2055,
    tag: "de-CH",
  },
  el: {
    language: "Greek",
    location: null,
    id: 8,
    tag: "el",
  },
  "el-cy": {
    language: "Greek",
    location: "Cyprus",
    id: 4096,
    tag: "el-CY",
  },
  "el-gr": {
    language: "Greek",
    location: "Greece",
    id: 1032,
    tag: "el-GR",
  },
  kl: {
    language: "Greenlandic",
    location: null,
    id: 111,
    tag: "kl",
  },
  "kl-gl": {
    language: "Greenlandic",
    location: "Greenland",
    id: 1135,
    tag: "kl-GL",
  },
  gn: {
    language: "Guarani",
    location: null,
    id: 116,
    tag: "gn",
  },
  "gn-py": {
    language: "Guarani",
    location: "Paraguay",
    id: 1140,
    tag: "gn-PY",
  },
  gu: {
    language: "Gujarati",
    location: null,
    id: 71,
    tag: "gu",
  },
  "gu-in": {
    language: "Gujarati",
    location: "India",
    id: 1095,
    tag: "gu-IN",
  },
  guz: {
    language: "Gusii",
    location: null,
    id: 4096,
    tag: "guz",
  },
  "guz-ke": {
    language: "Gusii",
    location: "Kenya",
    id: 4096,
    tag: "guz-KE",
  },
  ha: {
    language: "Hausa (Latin)",
    location: null,
    id: 104,
    tag: "ha",
  },
  "ha-latn": {
    language: "Hausa (Latin)",
    location: null,
    id: 31848,
    tag: "ha-Latn",
    version: "Windows 7",
  },
  "ha-latn-gh": {
    language: "Hausa (Latin)",
    location: "Ghana",
    id: 4096,
    tag: "ha-Latn-GH",
  },
  "ha-latn-ne": {
    language: "Hausa (Latin)",
    location: "Niger",
    id: 4096,
    tag: "ha-Latn-NE",
  },
  "ha-latn-ng": {
    language: "Hausa (Latin)",
    location: "Nigeria",
    id: 1128,
    tag: "ha-Latn-NG",
  },
  haw: {
    language: "Hawaiian",
    location: null,
    id: 117,
    tag: "haw",
  },
  "haw-us": {
    language: "Hawaiian",
    location: "United States",
    id: 1141,
    tag: "haw-US",
  },
  he: {
    language: "Hebrew",
    location: null,
    id: 13,
    tag: "he",
  },
  "he-il": {
    language: "Hebrew",
    location: "Israel",
    id: 1037,
    tag: "he-IL",
  },
  hi: {
    language: "Hindi",
    location: null,
    id: 57,
    tag: "hi",
  },
  "hi-in": {
    language: "Hindi",
    location: "India",
    id: 1081,
    tag: "hi-IN",
  },
  hu: {
    language: "Hungarian",
    location: null,
    id: 14,
    tag: "hu",
  },
  "hu-hu": {
    language: "Hungarian",
    location: "Hungary",
    id: 1038,
    tag: "hu-HU",
  },
  is: {
    language: "Icelandic",
    location: null,
    id: 15,
    tag: "is",
  },
  "is-is": {
    language: "Icelandic",
    location: "Iceland",
    id: 1039,
    tag: "is-IS",
  },
  ig: {
    language: "Igbo",
    location: null,
    id: 112,
    tag: "ig",
  },
  "ig-ng": {
    language: "Igbo",
    location: "Nigeria",
    id: 1136,
    tag: "ig-NG",
  },
  id: {
    language: "Indonesian",
    location: null,
    id: 33,
    tag: "id",
  },
  "id-id": {
    language: "Indonesian",
    location: "Indonesia",
    id: 1057,
    tag: "id-ID",
  },
  ia: {
    language: "Interlingua",
    location: null,
    id: 4096,
    tag: "ia",
  },
  "ia-fr": {
    language: "Interlingua",
    location: "France",
    id: 4096,
    tag: "ia-FR",
  },
  "ia-001": {
    language: "Interlingua",
    location: "World",
    id: 4096,
    tag: "ia-001",
  },
  iu: {
    language: "Inuktitut (Latin)",
    location: null,
    id: 93,
    tag: "iu",
  },
  "iu-latn": {
    language: "Inuktitut (Latin)",
    location: null,
    id: 31837,
    tag: "iu-Latn",
    version: "Windows 7",
  },
  "iu-latn-ca": {
    language: "Inuktitut (Latin)",
    location: "Canada",
    id: 2141,
    tag: "iu-Latn-CA",
  },
  "iu-cans": {
    language: "Inuktitut (Syllabics)",
    location: null,
    id: 30813,
    tag: "iu-Cans",
    version: "Windows 7",
  },
  "iu-cans-ca": {
    language: "Inuktitut (Syllabics)",
    location: "Canada",
    id: 1117,
    tag: "iu-Cans-CA",
  },
  ga: {
    language: "Irish",
    location: null,
    id: 60,
    tag: "ga",
    version: "Windows 7",
  },
  "ga-ie": {
    language: "Irish",
    location: "Ireland",
    id: 2108,
    tag: "ga-IE",
  },
  it: {
    language: "Italian",
    location: null,
    id: 16,
    tag: "it",
  },
  "it-it": {
    language: "Italian",
    location: "Italy",
    id: 1040,
    tag: "it-IT",
  },
  "it-sm": {
    language: "Italian",
    location: "San Marino",
    id: 4096,
    tag: "it-SM",
  },
  "it-ch": {
    language: "Italian",
    location: "Switzerland",
    id: 2064,
    tag: "it-CH",
  },
  "it-va": {
    language: "Italian",
    location: "Vatican City",
    id: 4096,
    tag: "it-VA",
  },
  ja: {
    language: "Japanese",
    location: null,
    id: 17,
    tag: "ja",
  },
  "ja-jp": {
    language: "Japanese",
    location: "Japan",
    id: 1041,
    tag: "ja-JP",
  },
  jv: {
    language: "Javanese",
    location: null,
    id: 4096,
    tag: "jv",
  },
  "jv-latn": {
    language: "Javanese",
    location: "Latin",
    id: 4096,
    tag: "jv-Latn",
  },
  "jv-latn-id": {
    language: "Javanese",
    location: "Latin, Indonesia",
    id: 4096,
    tag: "jv-Latn-ID",
  },
  dyo: {
    language: "Jola-Fonyi",
    location: null,
    id: 4096,
    tag: "dyo",
  },
  "dyo-sn": {
    language: "Jola-Fonyi",
    location: "Senegal",
    id: 4096,
    tag: "dyo-SN",
  },
  kea: {
    language: "Kabuverdianu",
    location: null,
    id: 4096,
    tag: "kea",
  },
  "kea-cv": {
    language: "Kabuverdianu",
    location: "Cabo Verde",
    id: 4096,
    tag: "kea-CV",
  },
  kab: {
    language: "Kabyle",
    location: null,
    id: 4096,
    tag: "kab",
  },
  "kab-dz": {
    language: "Kabyle",
    location: "Algeria",
    id: 4096,
    tag: "kab-DZ",
  },
  kkj: {
    language: "Kako",
    location: null,
    id: 4096,
    tag: "kkj",
  },
  "kkj-cm": {
    language: "Kako",
    location: "Cameroon",
    id: 4096,
    tag: "kkj-CM",
  },
  kln: {
    language: "Kalenjin",
    location: null,
    id: 4096,
    tag: "kln",
  },
  "kln-ke": {
    language: "Kalenjin",
    location: "Kenya",
    id: 4096,
    tag: "kln-KE",
  },
  kam: {
    language: "Kamba",
    location: null,
    id: 4096,
    tag: "kam",
  },
  "kam-ke": {
    language: "Kamba",
    location: "Kenya",
    id: 4096,
    tag: "kam-KE",
  },
  kn: {
    language: "Kannada",
    location: null,
    id: 75,
    tag: "kn",
  },
  "kn-in": {
    language: "Kannada",
    location: "India",
    id: 1099,
    tag: "kn-IN",
  },
  ks: {
    language: "Kashmiri",
    location: null,
    id: 96,
    tag: "ks",
  },
  "ks-arab": {
    language: "Kashmiri",
    location: "Perso-Arabic",
    id: 1120,
    tag: "ks-Arab",
  },
  "ks-arab-in": {
    language: "Kashmiri",
    location: "Perso-Arabic",
    id: 4096,
    tag: "ks-Arab-IN",
  },
  kk: {
    language: "Kazakh",
    location: null,
    id: 63,
    tag: "kk",
  },
  "kk-kz": {
    language: "Kazakh",
    location: "Kazakhstan",
    id: 1087,
    tag: "kk-KZ",
  },
  km: {
    language: "Khmer",
    location: null,
    id: 83,
    tag: "km",
  },
  "km-kh": {
    language: "Khmer",
    location: "Cambodia",
    id: 1107,
    tag: "km-KH",
  },
  quc: {
    language: "K'iche",
    location: null,
    id: 134,
    tag: "quc",
  },
  "quc-latn-gt": {
    language: "K'iche",
    location: "Guatemala",
    id: 1158,
    tag: "quc-Latn-GT",
  },
  ki: {
    language: "Kikuyu",
    location: null,
    id: 4096,
    tag: "ki",
  },
  "ki-ke": {
    language: "Kikuyu",
    location: "Kenya",
    id: 4096,
    tag: "ki-KE",
  },
  rw: {
    language: "Kinyarwanda",
    location: null,
    id: 135,
    tag: "rw",
  },
  "rw-rw": {
    language: "Kinyarwanda",
    location: "Rwanda",
    id: 1159,
    tag: "rw-RW",
  },
  sw: {
    language: "Kiswahili",
    location: null,
    id: 65,
    tag: "sw",
  },
  "sw-ke": {
    language: "Kiswahili",
    location: "Kenya",
    id: 1089,
    tag: "sw-KE",
  },
  "sw-tz": {
    language: "Kiswahili",
    location: "Tanzania",
    id: 4096,
    tag: "sw-TZ",
  },
  "sw-ug": {
    language: "Kiswahili",
    location: "Uganda",
    id: 4096,
    tag: "sw-UG",
  },
  kok: {
    language: "Konkani",
    location: null,
    id: 87,
    tag: "kok",
  },
  "kok-in": {
    language: "Konkani",
    location: "India",
    id: 1111,
    tag: "kok-IN",
  },
  ko: {
    language: "Korean",
    location: null,
    id: 18,
    tag: "ko",
  },
  "ko-kr": {
    language: "Korean",
    location: "Korea",
    id: 1042,
    tag: "ko-KR",
  },
  "ko-kp": {
    language: "Korean",
    location: "North Korea",
    id: 4096,
    tag: "ko-KP",
  },
  khq: {
    language: "Koyra Chiini",
    location: null,
    id: 4096,
    tag: "khq",
  },
  "khq-ml": {
    language: "Koyra Chiini",
    location: "Mali",
    id: 4096,
    tag: "khq-ML",
  },
  ses: {
    language: "Koyraboro Senni",
    location: null,
    id: 4096,
    tag: "ses",
  },
  "ses-ml": {
    language: "Koyraboro Senni",
    location: "Mali",
    id: 4096,
    tag: "ses-ML",
  },
  nmg: {
    language: "Kwasio",
    location: null,
    id: 4096,
    tag: "nmg",
  },
  "nmg-cm": {
    language: "Kwasio",
    location: "Cameroon",
    id: 4096,
    tag: "nmg-CM",
  },
  ky: {
    language: "Kyrgyz",
    location: null,
    id: 64,
    tag: "ky",
  },
  "ky-kg": {
    language: "Kyrgyz",
    location: "Kyrgyzstan",
    id: 1088,
    tag: "ky-KG",
  },
  "ku-arab-ir": {
    language: "Kurdish",
    location: "Perso-Arabic, Iran",
    id: 4096,
    tag: "ku-Arab-IR",
  },
  lkt: {
    language: "Lakota",
    location: null,
    id: 4096,
    tag: "lkt",
  },
  "lkt-us": {
    language: "Lakota",
    location: "United States",
    id: 4096,
    tag: "lkt-US",
  },
  lag: {
    language: "Langi",
    location: null,
    id: 4096,
    tag: "lag",
  },
  "lag-tz": {
    language: "Langi",
    location: "Tanzania",
    id: 4096,
    tag: "lag-TZ",
  },
  lo: {
    language: "Lao",
    location: null,
    id: 84,
    tag: "lo",
  },
  "lo-la": {
    language: "Lao",
    location: "Lao P.D.R.",
    id: 1108,
    tag: "lo-LA",
  },
  lv: {
    language: "Latvian",
    location: null,
    id: 38,
    tag: "lv",
  },
  "lv-lv": {
    language: "Latvian",
    location: "Latvia",
    id: 1062,
    tag: "lv-LV",
  },
  ln: {
    language: "Lingala",
    location: null,
    id: 4096,
    tag: "ln",
  },
  "ln-ao": {
    language: "Lingala",
    location: "Angola",
    id: 4096,
    tag: "ln-AO",
  },
  "ln-cf": {
    language: "Lingala",
    location: "Central African Republic",
    id: 4096,
    tag: "ln-CF",
  },
  "ln-cg": {
    language: "Lingala",
    location: "Congo",
    id: 4096,
    tag: "ln-CG",
  },
  "ln-cd": {
    language: "Lingala",
    location: "Congo DRC",
    id: 4096,
    tag: "ln-CD",
  },
  lt: {
    language: "Lithuanian",
    location: null,
    id: 39,
    tag: "lt",
  },
  "lt-lt": {
    language: "Lithuanian",
    location: "Lithuania",
    id: 1063,
    tag: "lt-LT",
  },
  nds: {
    language: "Low German",
    location: null,
    id: 4096,
    tag: "nds",
  },
  "nds-de": {
    language: "Low German",
    location: "Germany",
    id: 4096,
    tag: "nds-DE",
  },
  "nds-nl": {
    language: "Low German",
    location: "Netherlands",
    id: 4096,
    tag: "nds-NL",
  },
  dsb: {
    language: "Lower Sorbian",
    location: null,
    id: 31790,
    tag: "dsb",
    version: "Windows 7",
  },
  "dsb-de": {
    language: "Lower Sorbian",
    location: "Germany",
    id: 2094,
    tag: "dsb-DE",
  },
  lu: {
    language: "Luba-Katanga",
    location: null,
    id: 4096,
    tag: "lu",
  },
  "lu-cd": {
    language: "Luba-Katanga",
    location: "Congo DRC",
    id: 4096,
    tag: "lu-CD",
  },
  luo: {
    language: "Luo",
    location: null,
    id: 4096,
    tag: "luo",
  },
  "luo-ke": {
    language: "Luo",
    location: "Kenya",
    id: 4096,
    tag: "luo-KE",
  },
  lb: {
    language: "Luxembourgish",
    location: null,
    id: 110,
    tag: "lb",
  },
  "lb-lu": {
    language: "Luxembourgish",
    location: "Luxembourg",
    id: 1134,
    tag: "lb-LU",
  },
  luy: {
    language: "Luyia",
    location: null,
    id: 4096,
    tag: "luy",
  },
  "luy-ke": {
    language: "Luyia",
    location: "Kenya",
    id: 4096,
    tag: "luy-KE",
  },
  mk: {
    language: "Macedonian",
    location: null,
    id: 47,
    tag: "mk",
  },
  "mk-mk": {
    language: "Macedonian",
    location: "North Macedonia",
    id: 1071,
    tag: "mk-MK",
  },
  jmc: {
    language: "Machame",
    location: null,
    id: 4096,
    tag: "jmc",
  },
  "jmc-tz": {
    language: "Machame",
    location: "Tanzania",
    id: 4096,
    tag: "jmc-TZ",
  },
  mgh: {
    language: "Makhuwa-Meetto",
    location: null,
    id: 4096,
    tag: "mgh",
  },
  "mgh-mz": {
    language: "Makhuwa-Meetto",
    location: "Mozambique",
    id: 4096,
    tag: "mgh-MZ",
  },
  kde: {
    language: "Makonde",
    location: null,
    id: 4096,
    tag: "kde",
  },
  "kde-tz": {
    language: "Makonde",
    location: "Tanzania",
    id: 4096,
    tag: "kde-TZ",
  },
  mg: {
    language: "Malagasy",
    location: null,
    id: 4096,
    tag: "mg",
  },
  "mg-mg": {
    language: "Malagasy",
    location: "Madagascar",
    id: 4096,
    tag: "mg-MG",
  },
  ms: {
    language: "Malay",
    location: null,
    id: 62,
    tag: "ms",
  },
  "ms-bn": {
    language: "Malay",
    location: "Brunei Darussalam",
    id: 2110,
    tag: "ms-BN",
  },
  "ms-my": {
    language: "Malay",
    location: "Malaysia",
    id: 1086,
    tag: "ms-MY",
  },
  ml: {
    language: "Malayalam",
    location: null,
    id: 76,
    tag: "ml",
  },
  "ml-in": {
    language: "Malayalam",
    location: "India",
    id: 1100,
    tag: "ml-IN",
  },
  mt: {
    language: "Maltese",
    location: null,
    id: 58,
    tag: "mt",
  },
  "mt-mt": {
    language: "Maltese",
    location: "Malta",
    id: 1082,
    tag: "mt-MT",
  },
  gv: {
    language: "Manx",
    location: null,
    id: 4096,
    tag: "gv",
  },
  "gv-im": {
    language: "Manx",
    location: "Isle of Man",
    id: 4096,
    tag: "gv-IM",
  },
  mi: {
    language: "Maori",
    location: null,
    id: 129,
    tag: "mi",
  },
  "mi-nz": {
    language: "Maori",
    location: "New Zealand",
    id: 1153,
    tag: "mi-NZ",
  },
  arn: {
    language: "Mapudungun",
    location: null,
    id: 122,
    tag: "arn",
  },
  "arn-cl": {
    language: "Mapudungun",
    location: "Chile",
    id: 1146,
    tag: "arn-CL",
  },
  mr: {
    language: "Marathi",
    location: null,
    id: 78,
    tag: "mr",
  },
  "mr-in": {
    language: "Marathi",
    location: "India",
    id: 1102,
    tag: "mr-IN",
  },
  mas: {
    language: "Masai",
    location: null,
    id: 4096,
    tag: "mas",
  },
  "mas-ke": {
    language: "Masai",
    location: "Kenya",
    id: 4096,
    tag: "mas-KE",
  },
  "mas-tz": {
    language: "Masai",
    location: "Tanzania",
    id: 4096,
    tag: "mas-TZ",
  },
  "mzn-ir": {
    language: "Mazanderani",
    location: "Iran",
    id: 4096,
    tag: "mzn-IR",
  },
  mer: {
    language: "Meru",
    location: null,
    id: 4096,
    tag: "mer",
  },
  "mer-ke": {
    language: "Meru",
    location: "Kenya",
    id: 4096,
    tag: "mer-KE",
  },
  mgo: {
    language: "Meta'",
    location: null,
    id: 4096,
    tag: "mgo",
  },
  "mgo-cm": {
    language: "Meta'",
    location: "Cameroon",
    id: 4096,
    tag: "mgo-CM",
  },
  moh: {
    language: "Mohawk",
    location: null,
    id: 124,
    tag: "moh",
  },
  "moh-ca": {
    language: "Mohawk",
    location: "Canada",
    id: 1148,
    tag: "moh-CA",
  },
  mn: {
    language: "Mongolian (Cyrillic)",
    location: null,
    id: 80,
    tag: "mn",
  },
  "mn-cyrl": {
    language: "Mongolian (Cyrillic)",
    location: null,
    id: 30800,
    tag: "mn-Cyrl",
    version: "Windows 7",
  },
  "mn-mn": {
    language: "Mongolian (Cyrillic)",
    location: "Mongolia",
    id: 1104,
    tag: "mn-MN",
  },
  "mn-mong": {
    language: "Mongolian (Traditional Mongolian)",
    location: null,
    id: 31824,
    tag: "mn-Mong",
    version: "Windows 7",
  },
  "mn-mong-cn": {
    language: "Mongolian (Traditional Mongolian)",
    location: "People's Republic of China",
    id: 2128,
    tag: "mn-Mong-CN",
    version: "Windows V",
  },
  "mn-mong-mn": {
    language: "Mongolian (Traditional Mongolian)",
    location: "Mongolia",
    id: 3152,
    tag: "mn-Mong-MN",
    version: "Windows 7",
  },
  mfe: {
    language: "Morisyen",
    location: null,
    id: 4096,
    tag: "mfe",
  },
  "mfe-mu": {
    language: "Morisyen",
    location: "Mauritius",
    id: 4096,
    tag: "mfe-MU",
  },
  mua: {
    language: "Mundang",
    location: null,
    id: 4096,
    tag: "mua",
  },
  "mua-cm": {
    language: "Mundang",
    location: "Cameroon",
    id: 4096,
    tag: "mua-CM",
  },
  nqo: {
    language: "N'ko",
    location: null,
    id: 4096,
    tag: "nqo",
  },
  "nqo-gn": {
    language: "N'ko",
    location: "Guinea",
    id: 4096,
    tag: "nqo-GN",
  },
  naq: {
    language: "Nama",
    location: null,
    id: 4096,
    tag: "naq",
  },
  "naq-na": {
    language: "Nama",
    location: "Namibia",
    id: 4096,
    tag: "naq-NA",
  },
  ne: {
    language: "Nepali",
    location: null,
    id: 97,
    tag: "ne",
  },
  "ne-in": {
    language: "Nepali",
    location: "India",
    id: 2145,
    tag: "ne-IN",
  },
  "ne-np": {
    language: "Nepali",
    location: "Nepal",
    id: 1121,
    tag: "ne-NP",
  },
  nnh: {
    language: "Ngiemboon",
    location: null,
    id: 4096,
    tag: "nnh",
  },
  "nnh-cm": {
    language: "Ngiemboon",
    location: "Cameroon",
    id: 4096,
    tag: "nnh-CM",
  },
  jgo: {
    language: "Ngomba",
    location: null,
    id: 4096,
    tag: "jgo",
  },
  "jgo-cm": {
    language: "Ngomba",
    location: "Cameroon",
    id: 4096,
    tag: "jgo-CM",
  },
  "lrc-iq": {
    language: "Northern Luri",
    location: "Iraq",
    id: 4096,
    tag: "lrc-IQ",
  },
  "lrc-ir": {
    language: "Northern Luri",
    location: "Iran",
    id: 4096,
    tag: "lrc-IR",
  },
  nd: {
    language: "North Ndebele",
    location: null,
    id: 4096,
    tag: "nd",
  },
  "nd-zw": {
    language: "North Ndebele",
    location: "Zimbabwe",
    id: 4096,
    tag: "nd-ZW",
  },
  no: {
    language: "Norwegian (Bokmal)",
    location: null,
    id: 20,
    tag: "no",
  },
  nb: {
    language: "Norwegian (Bokmal)",
    location: null,
    id: 31764,
    tag: "nb",
  },
  "nb-no": {
    language: "Norwegian (Bokmal)",
    location: "Norway",
    id: 1044,
    tag: "nb-NO",
  },
  nn: {
    language: "Norwegian (Nynorsk)",
    location: null,
    id: 30740,
    tag: "nn",
  },
  "nn-no": {
    language: "Norwegian (Nynorsk)",
    location: "Norway",
    id: 2068,
    tag: "nn-NO",
  },
  "nb-sj": {
    language: "Norwegian Bokmål",
    location: "Svalbard and Jan Mayen",
    id: 4096,
    tag: "nb-SJ",
  },
  nus: {
    language: "Nuer",
    location: null,
    id: 4096,
    tag: "nus",
  },
  "nus-sd": {
    language: "Nuer",
    location: "Sudan",
    id: 4096,
    tag: "nus-SD",
  },
  "nus-ss": {
    language: "Nuer",
    location: "South Sudan",
    id: 4096,
    tag: "nus-SS",
  },
  nyn: {
    language: "Nyankole",
    location: null,
    id: 4096,
    tag: "nyn",
  },
  "nyn-ug": {
    language: "Nyankole",
    location: "Uganda",
    id: 4096,
    tag: "nyn-UG",
  },
  oc: {
    language: "Occitan",
    location: null,
    id: 130,
    tag: "oc",
  },
  "oc-fr": {
    language: "Occitan",
    location: "France",
    id: 1154,
    tag: "oc-FR",
  },
  or: {
    language: "Odia",
    location: null,
    id: 72,
    tag: "or",
  },
  "or-in": {
    language: "Odia",
    location: "India",
    id: 1096,
    tag: "or-IN",
  },
  om: {
    language: "Oromo",
    location: null,
    id: 114,
    tag: "om",
  },
  "om-et": {
    language: "Oromo",
    location: "Ethiopia",
    id: 1138,
    tag: "om-ET",
  },
  "om-ke": {
    language: "Oromo",
    location: "Kenya",
    id: 4096,
    tag: "om-KE",
  },
  os: {
    language: "Ossetian",
    location: null,
    id: 4096,
    tag: "os",
  },
  "os-ge": {
    language: "Ossetian",
    location: "Cyrillic, Georgia",
    id: 4096,
    tag: "os-GE",
  },
  "os-ru": {
    language: "Ossetian",
    location: "Cyrillic, Russia",
    id: 4096,
    tag: "os-RU",
  },
  ps: {
    language: "Pashto",
    location: null,
    id: 99,
    tag: "ps",
  },
  "ps-af": {
    language: "Pashto",
    location: "Afghanistan",
    id: 1123,
    tag: "ps-AF",
  },
  "ps-pk": {
    language: "Pashto",
    location: "Pakistan",
    id: 4096,
    tag: "ps-PK",
  },
  fa: {
    language: "Persian",
    location: null,
    id: 41,
    tag: "fa",
  },
  "fa-af": {
    language: "Persian",
    location: "Afghanistan",
    id: 4096,
    tag: "fa-AF",
  },
  "fa-ir": {
    language: "Persian",
    location: "Iran",
    id: 1065,
    tag: "fa-IR",
  },
  pl: {
    language: "Polish",
    location: null,
    id: 21,
    tag: "pl",
  },
  "pl-pl": {
    language: "Polish",
    location: "Poland",
    id: 1045,
    tag: "pl-PL",
  },
  pt: {
    language: "Portuguese",
    location: null,
    id: 22,
    tag: "pt",
  },
  "pt-ao": {
    language: "Portuguese",
    location: "Angola",
    id: 4096,
    tag: "pt-AO",
  },
  "pt-br": {
    language: "Portuguese",
    location: "Brazil",
    id: 1046,
    tag: "pt-BR",
  },
  "pt-cv": {
    language: "Portuguese",
    location: "Cabo Verde",
    id: 4096,
    tag: "pt-CV",
  },
  "pt-gq": {
    language: "Portuguese",
    location: "Equatorial Guinea",
    id: 4096,
    tag: "pt-GQ",
  },
  "pt-gw": {
    language: "Portuguese",
    location: "Guinea-Bissau",
    id: 4096,
    tag: "pt-GW",
  },
  "pt-lu": {
    language: "Portuguese",
    location: "Luxembourg",
    id: 4096,
    tag: "pt-LU",
  },
  "pt-mo": {
    language: "Portuguese",
    location: "Macao SAR",
    id: 4096,
    tag: "pt-MO",
  },
  "pt-mz": {
    language: "Portuguese",
    location: "Mozambique",
    id: 4096,
    tag: "pt-MZ",
  },
  "pt-pt": {
    language: "Portuguese",
    location: "Portugal",
    id: 2070,
    tag: "pt-PT",
  },
  "pt-st": {
    language: "Portuguese",
    location: "São Tomé and Príncipe",
    id: 4096,
    tag: "pt-ST",
  },
  "pt-ch": {
    language: "Portuguese",
    location: "Switzerland",
    id: 4096,
    tag: "pt-CH",
  },
  "pt-tl": {
    language: "Portuguese",
    location: "Timor-Leste",
    id: 4096,
    tag: "pt-TL",
  },
  "prg-001": {
    language: "Prussian",
    location: null,
    id: 4096,
    tag: "prg-001",
  },
  "qps-ploca": {
    language: "Pseudo Language",
    location:
      "Pseudo locale for east Asian/complex script localization testing",
    id: 1534,
    tag: "qps-ploca",
  },
  "qps-ploc": {
    language: "Pseudo Language",
    location: "Pseudo locale used for localization testing",
    id: 1281,
    tag: "qps-ploc",
  },
  "qps-plocm": {
    language: "Pseudo Language",
    location: "Pseudo locale used for localization testing of mirrored locales",
    id: 2559,
    tag: "qps-plocm",
  },
  pa: {
    language: "Punjabi",
    location: null,
    id: 70,
    tag: "pa",
  },
  "pa-arab": {
    language: "Punjabi",
    location: null,
    id: 31814,
    tag: "pa-Arab",
  },
  "pa-in": {
    language: "Punjabi",
    location: "India",
    id: 1094,
    tag: "pa-IN",
  },
  "pa-arab-pk": {
    language: "Punjabi",
    location: "Islamic Republic of Pakistan",
    id: 2118,
    tag: "pa-Arab-PK",
  },
  quz: {
    language: "Quechua",
    location: null,
    id: 107,
    tag: "quz",
  },
  "quz-bo": {
    language: "Quechua",
    location: "Bolivia",
    id: 1131,
    tag: "quz-BO",
  },
  "quz-ec": {
    language: "Quechua",
    location: "Ecuador",
    id: 2155,
    tag: "quz-EC",
  },
  "quz-pe": {
    language: "Quechua",
    location: "Peru",
    id: 3179,
    tag: "quz-PE",
  },
  ksh: {
    language: "Ripuarian",
    location: null,
    id: 4096,
    tag: "ksh",
  },
  "ksh-de": {
    language: "Ripuarian",
    location: "Germany",
    id: 4096,
    tag: "ksh-DE",
  },
  ro: {
    language: "Romanian",
    location: null,
    id: 24,
    tag: "ro",
  },
  "ro-md": {
    language: "Romanian",
    location: "Moldova",
    id: 2072,
    tag: "ro-MD",
  },
  "ro-ro": {
    language: "Romanian",
    location: "Romania",
    id: 1048,
    tag: "ro-RO",
  },
  rm: {
    language: "Romansh",
    location: null,
    id: 23,
    tag: "rm",
  },
  "rm-ch": {
    language: "Romansh",
    location: "Switzerland",
    id: 1047,
    tag: "rm-CH",
  },
  rof: {
    language: "Rombo",
    location: null,
    id: 4096,
    tag: "rof",
  },
  "rof-tz": {
    language: "Rombo",
    location: "Tanzania",
    id: 4096,
    tag: "rof-TZ",
  },
  rn: {
    language: "Rundi",
    location: null,
    id: 4096,
    tag: "rn",
  },
  "rn-bi": {
    language: "Rundi",
    location: "Burundi",
    id: 4096,
    tag: "rn-BI",
  },
  ru: {
    language: "Russian",
    location: null,
    id: 25,
    tag: "ru",
  },
  "ru-by": {
    language: "Russian",
    location: "Belarus",
    id: 4096,
    tag: "ru-BY",
  },
  "ru-kz": {
    language: "Russian",
    location: "Kazakhstan",
    id: 4096,
    tag: "ru-KZ",
  },
  "ru-kg": {
    language: "Russian",
    location: "Kyrgyzstan",
    id: 4096,
    tag: "ru-KG",
  },
  "ru-md": {
    language: "Russian",
    location: "Moldova",
    id: 2073,
    tag: "ru-MD",
  },
  "ru-ru": {
    language: "Russian",
    location: "Russia",
    id: 1049,
    tag: "ru-RU",
  },
  "ru-ua": {
    language: "Russian",
    location: "Ukraine",
    id: 4096,
    tag: "ru-UA",
  },
  rwk: {
    language: "Rwa",
    location: null,
    id: 4096,
    tag: "rwk",
  },
  "rwk-tz": {
    language: "Rwa",
    location: "Tanzania",
    id: 4096,
    tag: "rwk-TZ",
  },
  ssy: {
    language: "Saho",
    location: null,
    id: 4096,
    tag: "ssy",
  },
  "ssy-er": {
    language: "Saho",
    location: "Eritrea",
    id: 4096,
    tag: "ssy-ER",
  },
  sah: {
    language: "Sakha",
    location: null,
    id: 133,
    tag: "sah",
  },
  "sah-ru": {
    language: "Sakha",
    location: "Russia",
    id: 1157,
    tag: "sah-RU",
  },
  saq: {
    language: "Samburu",
    location: null,
    id: 4096,
    tag: "saq",
  },
  "saq-ke": {
    language: "Samburu",
    location: "Kenya",
    id: 4096,
    tag: "saq-KE",
  },
  smn: {
    language: "Sami (Inari)",
    location: null,
    id: 28731,
    tag: "smn",
    version: "Windows 7",
  },
  "smn-fi": {
    language: "Sami (Inari)",
    location: "Finland",
    id: 9275,
    tag: "smn-FI",
  },
  smj: {
    language: "Sami (Lule)",
    location: null,
    id: 31803,
    tag: "smj",
    version: "Windows 7",
  },
  "smj-no": {
    language: "Sami (Lule)",
    location: "Norway",
    id: 4155,
    tag: "smj-NO",
  },
  "smj-se": {
    language: "Sami (Lule)",
    location: "Sweden",
    id: 5179,
    tag: "smj-SE",
  },
  se: {
    language: "Sami (Northern)",
    location: null,
    id: 59,
    tag: "se",
  },
  "se-fi": {
    language: "Sami (Northern)",
    location: "Finland",
    id: 3131,
    tag: "se-FI",
  },
  "se-no": {
    language: "Sami (Northern)",
    location: "Norway",
    id: 1083,
    tag: "se-NO",
  },
  "se-se": {
    language: "Sami (Northern)",
    location: "Sweden",
    id: 2107,
    tag: "se-SE",
  },
  sms: {
    language: "Sami (Skolt)",
    location: null,
    id: 29755,
    tag: "sms",
    version: "Windows 7",
  },
  "sms-fi": {
    language: "Sami (Skolt)",
    location: "Finland",
    id: 8251,
    tag: "sms-FI",
  },
  sma: {
    language: "Sami (Southern)",
    location: null,
    id: 30779,
    tag: "sma",
    version: "Windows 7",
  },
  "sma-no": {
    language: "Sami (Southern)",
    location: "Norway",
    id: 6203,
    tag: "sma-NO",
  },
  "sma-se": {
    language: "Sami (Southern)",
    location: "Sweden",
    id: 7227,
    tag: "sma-SE",
  },
  sg: {
    language: "Sango",
    location: null,
    id: 4096,
    tag: "sg",
  },
  "sg-cf": {
    language: "Sango",
    location: "Central African Republic",
    id: 4096,
    tag: "sg-CF",
  },
  sbp: {
    language: "Sangu",
    location: null,
    id: 4096,
    tag: "sbp",
  },
  "sbp-tz": {
    language: "Sangu",
    location: "Tanzania",
    id: 4096,
    tag: "sbp-TZ",
  },
  sa: {
    language: "Sanskrit",
    location: null,
    id: 79,
    tag: "sa",
  },
  "sa-in": {
    language: "Sanskrit",
    location: "India",
    id: 1103,
    tag: "sa-IN",
  },
  gd: {
    language: "Scottish Gaelic",
    location: null,
    id: 145,
    tag: "gd",
    version: "Windows 7",
  },
  "gd-gb": {
    language: "Scottish Gaelic",
    location: "United Kingdom",
    id: 1169,
    tag: "gd-GB",
  },
  seh: {
    language: "Sena",
    location: null,
    id: 4096,
    tag: "seh",
  },
  "seh-mz": {
    language: "Sena",
    location: "Mozambique",
    id: 4096,
    tag: "seh-MZ",
  },
  "sr-cyrl": {
    language: "Serbian (Cyrillic)",
    location: null,
    id: 27674,
    tag: "sr-Cyrl",
    version: "Windows 7",
  },
  "sr-cyrl-ba": {
    language: "Serbian (Cyrillic)",
    location: "Bosnia and Herzegovina",
    id: 7194,
    tag: "sr-Cyrl-BA",
  },
  "sr-cyrl-me": {
    language: "Serbian (Cyrillic)",
    location: "Montenegro",
    id: 12314,
    tag: "sr-Cyrl-ME",
  },
  "sr-cyrl-rs": {
    language: "Serbian (Cyrillic)",
    location: "Serbia",
    id: 10266,
    tag: "sr-Cyrl-RS",
  },
  "sr-cyrl-cs": {
    language: "Serbian (Cyrillic)",
    location: "Serbia and Montenegro (Former)",
    id: 3098,
    tag: "sr-Cyrl-CS",
  },
  "sr-latn": {
    language: "Serbian (Latin)",
    location: null,
    id: 28698,
    tag: "sr-Latn",
    version: "Windows 7",
  },
  sr: {
    language: "Serbian (Latin)",
    location: null,
    id: 31770,
    tag: "sr",
  },
  "sr-latn-ba": {
    language: "Serbian (Latin)",
    location: "Bosnia and Herzegovina",
    id: 6170,
    tag: "sr-Latn-BA",
  },
  "sr-latn-me": {
    language: "Serbian (Latin)",
    location: "Montenegro",
    id: 11290,
    tag: "sr-Latn-ME",
  },
  "sr-latn-rs": {
    language: "Serbian (Latin)",
    location: "Serbia",
    id: 9242,
    tag: "sr-Latn-RS",
  },
  "sr-latn-cs": {
    language: "Serbian (Latin)",
    location: "Serbia and Montenegro (Former)",
    id: 2074,
    tag: "sr-Latn-CS",
  },
  nso: {
    language: "Sesotho sa Leboa",
    location: null,
    id: 108,
    tag: "nso",
  },
  "nso-za": {
    language: "Sesotho sa Leboa",
    location: "South Africa",
    id: 1132,
    tag: "nso-ZA",
  },
  tn: {
    language: "Setswana",
    location: null,
    id: 50,
    tag: "tn",
  },
  "tn-bw": {
    language: "Setswana",
    location: "Botswana",
    id: 2098,
    tag: "tn-BW",
  },
  "tn-za": {
    language: "Setswana",
    location: "South Africa",
    id: 1074,
    tag: "tn-ZA",
  },
  ksb: {
    language: "Shambala",
    location: null,
    id: 4096,
    tag: "ksb",
  },
  "ksb-tz": {
    language: "Shambala",
    location: "Tanzania",
    id: 4096,
    tag: "ksb-TZ",
  },
  sn: {
    language: "Shona",
    location: null,
    id: 4096,
    tag: "sn",
  },
  "sn-latn": {
    language: "Shona",
    location: "Latin",
    id: 4096,
    tag: "sn-Latn",
  },
  "sn-latn-zw": {
    language: "Shona",
    location: "Zimbabwe",
    id: 4096,
    tag: "sn-Latn-ZW",
  },
  sd: {
    language: "Sindhi",
    location: null,
    id: 89,
    tag: "sd",
  },
  "sd-arab": {
    language: "Sindhi",
    location: null,
    id: 31833,
    tag: "sd-Arab",
  },
  "sd-arab-pk": {
    language: "Sindhi",
    location: "Islamic Republic of Pakistan",
    id: 2137,
    tag: "sd-Arab-PK",
  },
  si: {
    language: "Sinhala",
    location: null,
    id: 91,
    tag: "si",
  },
  "si-lk": {
    language: "Sinhala",
    location: "Sri Lanka",
    id: 1115,
    tag: "si-LK",
  },
  sk: {
    language: "Slovak",
    location: null,
    id: 27,
    tag: "sk",
  },
  "sk-sk": {
    language: "Slovak",
    location: "Slovakia",
    id: 1051,
    tag: "sk-SK",
  },
  sl: {
    language: "Slovenian",
    location: null,
    id: 36,
    tag: "sl",
  },
  "sl-si": {
    language: "Slovenian",
    location: "Slovenia",
    id: 1060,
    tag: "sl-SI",
  },
  xog: {
    language: "Soga",
    location: null,
    id: 4096,
    tag: "xog",
  },
  "xog-ug": {
    language: "Soga",
    location: "Uganda",
    id: 4096,
    tag: "xog-UG",
  },
  so: {
    language: "Somali",
    location: null,
    id: 119,
    tag: "so",
  },
  "so-dj": {
    language: "Somali",
    location: "Djibouti",
    id: 4096,
    tag: "so-DJ",
  },
  "so-et": {
    language: "Somali",
    location: "Ethiopia",
    id: 4096,
    tag: "so-ET",
  },
  "so-ke": {
    language: "Somali",
    location: "Kenya",
    id: 4096,
    tag: "so-KE",
  },
  "so-so": {
    language: "Somali",
    location: "Somalia",
    id: 1143,
    tag: "so-SO",
  },
  st: {
    language: "Sotho",
    location: null,
    id: 48,
    tag: "st",
  },
  "st-za": {
    language: "Sotho",
    location: "South Africa",
    id: 1072,
    tag: "st-ZA",
  },
  nr: {
    language: "South Ndebele",
    location: null,
    id: 4096,
    tag: "nr",
  },
  "nr-za": {
    language: "South Ndebele",
    location: "South Africa",
    id: 4096,
    tag: "nr-ZA",
  },
  "st-ls": {
    language: "Southern Sotho",
    location: "Lesotho",
    id: 4096,
    tag: "st-LS",
  },
  es: {
    language: "Spanish",
    location: null,
    id: 10,
    tag: "es",
  },
  "es-ar": {
    language: "Spanish",
    location: "Argentina",
    id: 11274,
    tag: "es-AR",
  },
  "es-bz": {
    language: "Spanish",
    location: "Belize",
    id: 4096,
    tag: "es-BZ",
  },
  "es-ve": {
    language: "Spanish",
    location: "Bolivarian Republic of Venezuela",
    id: 8202,
    tag: "es-VE",
  },
  "es-bo": {
    language: "Spanish",
    location: "Bolivia",
    id: 16394,
    tag: "es-BO",
  },
  "es-br": {
    language: "Spanish",
    location: "Brazil",
    id: 4096,
    tag: "es-BR",
  },
  "es-cl": {
    language: "Spanish",
    location: "Chile",
    id: 13322,
    tag: "es-CL",
  },
  "es-co": {
    language: "Spanish",
    location: "Colombia",
    id: 9226,
    tag: "es-CO",
  },
  "es-cr": {
    language: "Spanish",
    location: "Costa Rica",
    id: 5130,
    tag: "es-CR",
  },
  "es-cu": {
    language: "Spanish",
    location: "Cuba",
    id: 23562,
    tag: "es-CU",
  },
  "es-do": {
    language: "Spanish",
    location: "Dominican Republic",
    id: 7178,
    tag: "es-DO",
  },
  "es-ec": {
    language: "Spanish",
    location: "Ecuador",
    id: 12298,
    tag: "es-EC",
  },
  "es-sv": {
    language: "Spanish",
    location: "El Salvador",
    id: 17418,
    tag: "es-SV",
  },
  "es-gq": {
    language: "Spanish",
    location: "Equatorial Guinea",
    id: 4096,
    tag: "es-GQ",
  },
  "es-gt": {
    language: "Spanish",
    location: "Guatemala",
    id: 4106,
    tag: "es-GT",
  },
  "es-hn": {
    language: "Spanish",
    location: "Honduras",
    id: 18442,
    tag: "es-HN",
  },
  "es-419": {
    language: "Spanish",
    location: "Latin America",
    id: 22538,
    tag: "es-419",
  },
  "es-mx": {
    language: "Spanish",
    location: "Mexico",
    id: 2058,
    tag: "es-MX",
  },
  "es-ni": {
    language: "Spanish",
    location: "Nicaragua",
    id: 19466,
    tag: "es-NI",
  },
  "es-pa": {
    language: "Spanish",
    location: "Panama",
    id: 6154,
    tag: "es-PA",
  },
  "es-py": {
    language: "Spanish",
    location: "Paraguay",
    id: 15370,
    tag: "es-PY",
  },
  "es-pe": {
    language: "Spanish",
    location: "Peru",
    id: 10250,
    tag: "es-PE",
  },
  "es-ph": {
    language: "Spanish",
    location: "Philippines",
    id: 4096,
    tag: "es-PH",
  },
  "es-pr": {
    language: "Spanish",
    location: "Puerto Rico",
    id: 20490,
    tag: "es-PR",
  },
  "es-es_tradnl": {
    language: "Spanish",
    location: "Spain",
    id: 1034,
    tag: "es-ES_tradnl",
  },
  "es-es": {
    language: "Spanish",
    location: "Spain",
    id: 3082,
    tag: "es-ES",
  },
  "es-us": {
    language: "Spanish",
    location: "UnitedStates",
    id: 21514,
    tag: "es-US",
  },
  "es-uy": {
    language: "Spanish",
    location: "Uruguay",
    id: 14346,
    tag: "es-UY",
  },
  zgh: {
    language: "Standard Moroccan Tamazight",
    location: null,
    id: 4096,
    tag: "zgh",
  },
  "zgh-tfng-ma": {
    language: "Standard Moroccan Tamazight",
    location: "Morocco",
    id: 4096,
    tag: "zgh-Tfng-MA",
  },
  "zgh-tfng": {
    language: "Standard Moroccan Tamazight",
    location: "Tifinagh",
    id: 4096,
    tag: "zgh-Tfng",
  },
  ss: {
    language: "Swati",
    location: null,
    id: 4096,
    tag: "ss",
  },
  "ss-za": {
    language: "Swati",
    location: "South Africa",
    id: 4096,
    tag: "ss-ZA",
  },
  "ss-sz": {
    language: "Swati",
    location: "Swaziland",
    id: 4096,
    tag: "ss-SZ",
  },
  sv: {
    language: "Swedish",
    location: null,
    id: 29,
    tag: "sv",
  },
  "sv-ax": {
    language: "Swedish",
    location: "Åland Islands",
    id: 4096,
    tag: "sv-AX",
  },
  "sv-fi": {
    language: "Swedish",
    location: "Finland",
    id: 2077,
    tag: "sv-FI",
  },
  "sv-se": {
    language: "Swedish",
    location: "Sweden",
    id: 1053,
    tag: "sv-SE",
  },
  syr: {
    language: "Syriac",
    location: null,
    id: 90,
    tag: "syr",
  },
  "syr-sy": {
    language: "Syriac",
    location: "Syria",
    id: 1114,
    tag: "syr-SY",
  },
  shi: {
    language: "Tachelhit",
    location: null,
    id: 4096,
    tag: "shi",
  },
  "shi-tfng": {
    language: "Tachelhit",
    location: "Tifinagh",
    id: 4096,
    tag: "shi-Tfng",
  },
  "shi-tfng-ma": {
    language: "Tachelhit",
    location: "Tifinagh, Morocco",
    id: 4096,
    tag: "shi-Tfng-MA",
  },
  "shi-latn": {
    language: "Tachelhit (Latin)",
    location: null,
    id: 4096,
    tag: "shi-Latn",
  },
  "shi-latn-ma": {
    language: "Tachelhit (Latin)",
    location: "Morocco",
    id: 4096,
    tag: "shi-Latn-MA",
  },
  dav: {
    language: "Taita",
    location: null,
    id: 4096,
    tag: "dav",
  },
  "dav-ke": {
    language: "Taita",
    location: "Kenya",
    id: 4096,
    tag: "dav-KE",
  },
  tg: {
    language: "Tajik (Cyrillic)",
    location: null,
    id: 40,
    tag: "tg",
  },
  "tg-cyrl": {
    language: "Tajik (Cyrillic)",
    location: null,
    id: 31784,
    tag: "tg-Cyrl",
    version: "Windows 7",
  },
  "tg-cyrl-tj": {
    language: "Tajik (Cyrillic)",
    location: "Tajikistan",
    id: 1064,
    tag: "tg-Cyrl-TJ",
  },
  tzm: {
    language: "Tamazight (Latin)",
    location: null,
    id: 95,
    tag: "tzm",
  },
  "tzm-latn": {
    language: "Tamazight (Latin)",
    location: null,
    id: 31839,
    tag: "tzm-Latn",
    version: "Windows 7",
  },
  "tzm-latn-dz": {
    language: "Tamazight (Latin)",
    location: "Algeria",
    id: 2143,
    tag: "tzm-Latn-DZ",
  },
  ta: {
    language: "Tamil",
    location: null,
    id: 73,
    tag: "ta",
  },
  "ta-in": {
    language: "Tamil",
    location: "India",
    id: 1097,
    tag: "ta-IN",
  },
  "ta-my": {
    language: "Tamil",
    location: "Malaysia",
    id: 4096,
    tag: "ta-MY",
  },
  "ta-sg": {
    language: "Tamil",
    location: "Singapore",
    id: 4096,
    tag: "ta-SG",
  },
  "ta-lk": {
    language: "Tamil",
    location: "Sri Lanka",
    id: 2121,
    tag: "ta-LK",
  },
  twq: {
    language: "Tasawaq",
    location: null,
    id: 4096,
    tag: "twq",
  },
  "twq-ne": {
    language: "Tasawaq",
    location: "Niger",
    id: 4096,
    tag: "twq-NE",
  },
  tt: {
    language: "Tatar",
    location: null,
    id: 68,
    tag: "tt",
  },
  "tt-ru": {
    language: "Tatar",
    location: "Russia",
    id: 1092,
    tag: "tt-RU",
  },
  te: {
    language: "Telugu",
    location: null,
    id: 74,
    tag: "te",
  },
  "te-in": {
    language: "Telugu",
    location: "India",
    id: 1098,
    tag: "te-IN",
  },
  teo: {
    language: "Teso",
    location: null,
    id: 4096,
    tag: "teo",
  },
  "teo-ke": {
    language: "Teso",
    location: "Kenya",
    id: 4096,
    tag: "teo-KE",
  },
  "teo-ug": {
    language: "Teso",
    location: "Uganda",
    id: 4096,
    tag: "teo-UG",
  },
  th: {
    language: "Thai",
    location: null,
    id: 30,
    tag: "th",
  },
  "th-th": {
    language: "Thai",
    location: "Thailand",
    id: 1054,
    tag: "th-TH",
  },
  bo: {
    language: "Tibetan",
    location: null,
    id: 81,
    tag: "bo",
  },
  "bo-in": {
    language: "Tibetan",
    location: "India",
    id: 4096,
    tag: "bo-IN",
  },
  "bo-cn": {
    language: "Tibetan",
    location: "People's Republic of China",
    id: 1105,
    tag: "bo-CN",
  },
  tig: {
    language: "Tigre",
    location: null,
    id: 4096,
    tag: "tig",
  },
  "tig-er": {
    language: "Tigre",
    location: "Eritrea",
    id: 4096,
    tag: "tig-ER",
  },
  ti: {
    language: "Tigrinya",
    location: null,
    id: 115,
    tag: "ti",
  },
  "ti-er": {
    language: "Tigrinya",
    location: "Eritrea",
    id: 2163,
    tag: "ti-ER",
  },
  "ti-et": {
    language: "Tigrinya",
    location: "Ethiopia",
    id: 1139,
    tag: "ti-ET",
  },
  to: {
    language: "Tongan",
    location: null,
    id: 4096,
    tag: "to",
  },
  "to-to": {
    language: "Tongan",
    location: "Tonga",
    id: 4096,
    tag: "to-TO",
  },
  ts: {
    language: "Tsonga",
    location: null,
    id: 49,
    tag: "ts",
  },
  "ts-za": {
    language: "Tsonga",
    location: "South Africa",
    id: 1073,
    tag: "ts-ZA",
  },
  tr: {
    language: "Turkish",
    location: null,
    id: 31,
    tag: "tr",
  },
  "tr-cy": {
    language: "Turkish",
    location: "Cyprus",
    id: 4096,
    tag: "tr-CY",
  },
  "tr-tr": {
    language: "Turkish",
    location: "Turkey",
    id: 1055,
    tag: "tr-TR",
  },
  tk: {
    language: "Turkmen",
    location: null,
    id: 66,
    tag: "tk",
  },
  "tk-tm": {
    language: "Turkmen",
    location: "Turkmenistan",
    id: 1090,
    tag: "tk-TM",
  },
  uk: {
    language: "Ukrainian",
    location: null,
    id: 34,
    tag: "uk",
  },
  "uk-ua": {
    language: "Ukrainian",
    location: "Ukraine",
    id: 1058,
    tag: "uk-UA",
  },
  hsb: {
    language: "Upper Sorbian",
    location: null,
    id: 46,
    tag: "hsb",
  },
  "hsb-de": {
    language: "Upper Sorbian",
    location: "Germany",
    id: 1070,
    tag: "hsb-DE",
  },
  ur: {
    language: "Urdu",
    location: null,
    id: 32,
    tag: "ur",
  },
  "ur-in": {
    language: "Urdu",
    location: "India",
    id: 2080,
    tag: "ur-IN",
  },
  "ur-pk": {
    language: "Urdu",
    location: "Islamic Republic of Pakistan",
    id: 1056,
    tag: "ur-PK",
  },
  ug: {
    language: "Uyghur",
    location: null,
    id: 128,
    tag: "ug",
  },
  "ug-cn": {
    language: "Uyghur",
    location: "People's Republic of China",
    id: 1152,
    tag: "ug-CN",
  },
  "uz-arab": {
    language: "Uzbek",
    location: "Perso-Arabic",
    id: 4096,
    tag: "uz-Arab",
  },
  "uz-arab-af": {
    language: "Uzbek",
    location: "Perso-Arabic, Afghanistan",
    id: 4096,
    tag: "uz-Arab-AF",
  },
  "uz-cyrl": {
    language: "Uzbek (Cyrillic)",
    location: null,
    id: 30787,
    tag: "uz-Cyrl",
    version: "Windows 7",
  },
  "uz-cyrl-uz": {
    language: "Uzbek (Cyrillic)",
    location: "Uzbekistan",
    id: 2115,
    tag: "uz-Cyrl-UZ",
  },
  uz: {
    language: "Uzbek (Latin)",
    location: null,
    id: 67,
    tag: "uz",
  },
  "uz-latn": {
    language: "Uzbek (Latin)",
    location: null,
    id: 31811,
    tag: "uz-Latn",
    version: "Windows7",
  },
  "uz-latn-uz": {
    language: "Uzbek (Latin)",
    location: "Uzbekistan",
    id: 1091,
    tag: "uz-Latn-UZ",
  },
  vai: {
    language: "Vai",
    location: null,
    id: 4096,
    tag: "vai",
  },
  "vai-vaii": {
    language: "Vai",
    location: null,
    id: 4096,
    tag: "vai-Vaii",
  },
  "vai-vaii-lr": {
    language: "Vai",
    location: "Liberia",
    id: 4096,
    tag: "vai-Vaii-LR",
  },
  "vai-latn-lr": {
    language: "Vai (Latin)",
    location: "Liberia",
    id: 4096,
    tag: "vai-Latn-LR",
  },
  "vai-latn": {
    language: "Vai (Latin)",
    location: null,
    id: 4096,
    tag: "vai-Latn",
  },
  "ca-es-": {
    language: "Valencian",
    location: "Spain",
    id: 2051,
    tag: "ca-ES-",
  },
  ve: {
    language: "Venda",
    location: null,
    id: 51,
    tag: "ve",
  },
  "ve-za": {
    language: "Venda",
    location: "South Africa",
    id: 1075,
    tag: "ve-ZA",
  },
  vi: {
    language: "Vietnamese",
    location: null,
    id: 42,
    tag: "vi",
  },
  "vi-vn": {
    language: "Vietnamese",
    location: "Vietnam",
    id: 1066,
    tag: "vi-VN",
  },
  vo: {
    language: "Volapük",
    location: null,
    id: 4096,
    tag: "vo",
  },
  "vo-001": {
    language: "Volapük",
    location: "World",
    id: 4096,
    tag: "vo-001",
  },
  vun: {
    language: "Vunjo",
    location: null,
    id: 4096,
    tag: "vun",
  },
  "vun-tz": {
    language: "Vunjo",
    location: "Tanzania",
    id: 4096,
    tag: "vun-TZ",
  },
  wae: {
    language: "Walser",
    location: null,
    id: 4096,
    tag: "wae",
  },
  "wae-ch": {
    language: "Walser",
    location: "Switzerland",
    id: 4096,
    tag: "wae-CH",
  },
  cy: {
    language: "Welsh",
    location: null,
    id: 82,
    tag: "cy",
  },
  "cy-gb": {
    language: "Welsh",
    location: "United Kingdom",
    id: 1106,
    tag: "cy-GB",
    version: "ReleaseE1",
  },
  wal: {
    language: "Wolaytta",
    location: null,
    id: 4096,
    tag: "wal",
  },
  "wal-et": {
    language: "Wolaytta",
    location: "Ethiopia",
    id: 4096,
    tag: "wal-ET",
  },
  wo: {
    language: "Wolof",
    location: null,
    id: 136,
    tag: "wo",
  },
  "wo-sn": {
    language: "Wolof",
    location: "Senegal",
    id: 1160,
    tag: "wo-SN",
  },
  xh: {
    language: "Xhosa",
    location: null,
    id: 52,
    tag: "xh",
  },
  "xh-za": {
    language: "Xhosa",
    location: "South Africa",
    id: 1076,
    tag: "xh-ZA",
  },
  yav: {
    language: "Yangben",
    location: null,
    id: 4096,
    tag: "yav",
  },
  "yav-cm": {
    language: "Yangben",
    location: "Cameroon",
    id: 4096,
    tag: "yav-CM",
  },
  ii: {
    language: "Yi",
    location: null,
    id: 120,
    tag: "ii",
  },
  "ii-cn": {
    language: "Yi",
    location: "People's Republic of China",
    id: 1144,
    tag: "ii-CN",
  },
  yo: {
    language: "Yoruba",
    location: null,
    id: 106,
    tag: "yo",
  },
  "yo-bj": {
    language: "Yoruba",
    location: "Benin",
    id: 4096,
    tag: "yo-BJ",
  },
  "yo-ng": {
    language: "Yoruba",
    location: "Nigeria",
    id: 1130,
    tag: "yo-NG",
  },
  dje: {
    language: "Zarma",
    location: null,
    id: 4096,
    tag: "dje",
  },
  "dje-ne": {
    language: "Zarma",
    location: "Niger",
    id: 4096,
    tag: "dje-NE",
  },
  zu: {
    language: "Zulu",
    location: null,
    id: 53,
    tag: "zu",
  },
  "zu-za": {
    language: "Zulu",
    location: "South Africa",
    id: 1077,
    tag: "zu-ZA",
  },
};

export default lookup;
